var items = {
  "block.minecraft.acacia_button": "Akasiya Düymə",
  "block.minecraft.acacia_door": "Akasiya Qapı",
  "block.minecraft.acacia_fence": "Akasiya Çəpər",
  "block.minecraft.acacia_fence_gate": "Akasiya Çəpər Qapısı",
  "block.minecraft.acacia_hanging_sign": "Akasiya Asma İşarəsi",
  "block.minecraft.acacia_leaves": "Akasiya Yarpaqları",
  "block.minecraft.acacia_log": "Akasiya kötüyü",
  "block.minecraft.acacia_planks": "Akasiya Taxta",
  "block.minecraft.acacia_pressure_plate": "Akasiya Təyziq Təbəqəsi",
  "block.minecraft.acacia_sapling": "Akasiya Fidanı",
  "block.minecraft.acacia_shelf": "Akasiya Rəfi",
  "block.minecraft.acacia_sign": "Akasiya Lövhə",
  "block.minecraft.acacia_slab": "Akasiya Pillə",
  "block.minecraft.acacia_stairs": "Akasiya Pilləkən",
  "block.minecraft.acacia_trapdoor": "Akasiya Tələ Qapısı",
  "block.minecraft.acacia_wall_hanging_sign": "Akasiya Asma İşarəsi",
  "block.minecraft.acacia_wall_sign": "Divarda Akasiya Lövhə",
  "block.minecraft.acacia_wood": "Akasiya Odunu",
  "block.minecraft.activator_rail": "Aktivləyiçi Rels",
  "block.minecraft.air": "Hava",
  "block.minecraft.allium": "Xristof Soğanı",
  "block.minecraft.amethyst_block": "Ametist bloku",
  "block.minecraft.amethyst_cluster": "Ametist salxımı",
  "block.minecraft.ancient_debris": "Qədim qalıq",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezit pillə",
  "block.minecraft.andesite_stairs": "Andezit Pilləkən",
  "block.minecraft.andesite_wall": "Andezit Divar",
  "block.minecraft.anvil": "Dəmirçi Zindanı",
  "block.minecraft.attached_melon_stem": "Bağlı Qarpız Sapı",
  "block.minecraft.attached_pumpkin_stem": "Bağlı balqabaq Sapı",
  "block.minecraft.azalea": "Azaliya",
  "block.minecraft.azalea_leaves": "Azaliya yarpaqları",
  "block.minecraft.azure_bluet": "Hüstoniya",
  "block.minecraft.bamboo": "Bambuk",
  "block.minecraft.bamboo_block": "Bambuk bloku",
  "block.minecraft.bamboo_button": "Bambuk düymə",
  "block.minecraft.bamboo_door": "Bambuk qapı",
  "block.minecraft.bamboo_fence": "Bambuk Çəpər",
  "block.minecraft.bamboo_fence_gate": "Bambuk Çəpər Qapısı",
  "block.minecraft.bamboo_hanging_sign": "Bambuk Asma İşarəsi",
  "block.minecraft.bamboo_mosaic": "Bambuk mozaika",
  "block.minecraft.bamboo_mosaic_slab": "Bambuk mozaika plitəsi",
  "block.minecraft.bamboo_mosaic_stairs": "Bambuk mozaika pilləkənləri",
  "block.minecraft.bamboo_planks": "Bambuk taxtalar",
  "block.minecraft.bamboo_pressure_plate": "Bambuk təzyiq lövhəsi",
  "block.minecraft.bamboo_sapling": "Bambuk fidanı",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bambuk işarəsi",
  "block.minecraft.bamboo_slab": "Bambuk Plitələr",
  "block.minecraft.bamboo_stairs": "Bambuk pilləkənlər",
  "block.minecraft.bamboo_trapdoor": "Bambukdan tələ qapısı",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuk Divardan Asma Nişanı",
  "block.minecraft.bamboo_wall_sign": "Bambuk Divar İşarəsi",
  "block.minecraft.banner.base.black": "Tam qara sahə",
  "block.minecraft.banner.base.blue": "Tam göy sahə",
  "block.minecraft.banner.base.brown": "Tam qəhvəyi sahə",
  "block.minecraft.banner.base.cyan": "Tam firuzəyi sahə",
  "block.minecraft.banner.base.gray": "Tam boz sahə",
  "block.minecraft.banner.base.green": "Tam yaşıl sahə",
  "block.minecraft.banner.base.light_blue": "Tam açıq göy sahə",
  "block.minecraft.banner.base.light_gray": "Tam açıq boz sahə",
  "block.minecraft.banner.base.lime": "Tam açıq yaşıl sahə",
  "block.minecraft.banner.base.magenta": "Tam macenta sahə",
  "block.minecraft.banner.base.orange": "Tam narıncı sahə",
  "block.minecraft.banner.base.pink": "Tam çəhrayı sahə",
  "block.minecraft.banner.base.purple": "Tam bənövşəyi sahə",
  "block.minecraft.banner.base.red": "Tam qırmızı sahə",
  "block.minecraft.banner.base.white": "Tam ağ sahə",
  "block.minecraft.banner.base.yellow": "Tam sarı sahə",
  "block.minecraft.banner.border.black": "Qara Çərçivə",
  "block.minecraft.banner.border.blue": "Göy Çərçivə",
  "block.minecraft.banner.border.brown": "Qəhvəyi Çərçivə",
  "block.minecraft.banner.border.cyan": "Mavi Çərçivə",
  "block.minecraft.banner.border.gray": "Boz Çərçivə",
  "block.minecraft.banner.border.green": "Yaşıl Çərçivə",
  "block.minecraft.banner.border.light_blue": "Açıq Göy Çərçivə",
  "block.minecraft.banner.border.light_gray": "Açıq Boz Çərçivə",
  "block.minecraft.banner.border.lime": "Açıq Yaşıl Çərçivə",
  "block.minecraft.banner.border.magenta": "Magenta Çərçivə",
  "block.minecraft.banner.border.orange": "Narıncı Çərçivə",
  "block.minecraft.banner.border.pink": "Çəhrayı Çərçivə",
  "block.minecraft.banner.border.purple": "Bənövşəyi Çərçivə",
  "block.minecraft.banner.border.red": "Qırmızı Çərçivə",
  "block.minecraft.banner.border.white": "Ağ Çərçivə",
  "block.minecraft.banner.border.yellow": "Sarı Çərçivə",
  "block.minecraft.banner.bricks.black": "Qara Kərpic Desəni",
  "block.minecraft.banner.bricks.blue": "Göy Kərpic Desəni",
  "block.minecraft.banner.bricks.brown": "Qəhvəyi Kərpic Desəni",
  "block.minecraft.banner.bricks.cyan": "Mavi Kərpic Desəni",
  "block.minecraft.banner.bricks.gray": "Boz Kərpic Desəni",
  "block.minecraft.banner.bricks.green": "Yaşıl Kərpic Desəni",
  "block.minecraft.banner.bricks.light_blue": "Açık Göy Kərpic Desəni",
  "block.minecraft.banner.bricks.light_gray": "Açıq Boz Kərpic Desəni",
  "block.minecraft.banner.bricks.lime": "Açıq Yaşıl Kərpic Desəni",
  "block.minecraft.banner.bricks.magenta": "Magenta Kərpic Desəni",
  "block.minecraft.banner.bricks.orange": "Narıncı Kərpic Desəni",
  "block.minecraft.banner.bricks.pink": "Çəhrayı Kərpic Desəni",
  "block.minecraft.banner.bricks.purple": "Bənövşəyi Kərpic Desəni",
  "block.minecraft.banner.bricks.red": "Qırmızı Kərpic Desəni",
  "block.minecraft.banner.bricks.white": "Ağ Kərpic Desəni",
  "block.minecraft.banner.bricks.yellow": "Sarı Kərpic Desəni",
  "block.minecraft.banner.circle.black": "Qara Dairə",
  "block.minecraft.banner.circle.blue": "Göy Dairə",
  "block.minecraft.banner.circle.brown": "Qəhvəyi Dairə",
  "block.minecraft.banner.circle.cyan": "Mavi Dairə",
  "block.minecraft.banner.circle.gray": "Boz Dairə",
  "block.minecraft.banner.circle.green": "Yaşıl Dairə",
  "block.minecraft.banner.circle.light_blue": "Açıq Göy Dairə",
  "block.minecraft.banner.circle.light_gray": "Açıq Boz Dairə",
  "block.minecraft.banner.circle.lime": "Açıq Yaşıl Dairə",
  "block.minecraft.banner.circle.magenta": "Magenta Dairə",
  "block.minecraft.banner.circle.orange": "Narıncı Dairə",
  "block.minecraft.banner.circle.pink": "Çəhrayı Dairə",
  "block.minecraft.banner.circle.purple": "Bənövşəyi Dairə",
  "block.minecraft.banner.circle.red": "Qırmızı Dairə",
  "block.minecraft.banner.circle.white": "Ağ Dairə",
  "block.minecraft.banner.circle.yellow": "Sarı Dairə",
  "block.minecraft.banner.creeper.black": "Qara Creeper Şəkli",
  "block.minecraft.banner.creeper.blue": "Göy Creeper Şəkli",
  "block.minecraft.banner.creeper.brown": "Qəhvəyi Creeper Şəkli",
  "block.minecraft.banner.creeper.cyan": "Mavi Creeper Şəkli",
  "block.minecraft.banner.creeper.gray": "Boz Creeper Şəkli",
  "block.minecraft.banner.creeper.green": "Yaşıl Creeper Şəkli",
  "block.minecraft.banner.creeper.light_blue": "Açıq Göy Creeper Şəkli",
  "block.minecraft.banner.creeper.light_gray": "Açıq Boz Creeper Şəkli",
  "block.minecraft.banner.creeper.lime": "Açıq Yaşıl Creeper Şəkli",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper Şəkli",
  "block.minecraft.banner.creeper.orange": "Narıncı Creeper Şəkli",
  "block.minecraft.banner.creeper.pink": "Çəhrayı Creeper Şəkli",
  "block.minecraft.banner.creeper.purple": "Bənövşəyi Creeper Şəkli",
  "block.minecraft.banner.creeper.red": "Qırmızı Creeper Şəkli",
  "block.minecraft.banner.creeper.white": "Ağ Creeper Şəkli",
  "block.minecraft.banner.creeper.yellow": "Sarı Creeper Şəkli",
  "block.minecraft.banner.cross.black": "Qara Çarpı",
  "block.minecraft.banner.cross.blue": "Göy Çarpı",
  "block.minecraft.banner.cross.brown": "Qəhvəyi Çarpı",
  "block.minecraft.banner.cross.cyan": "Mavi Çarpı",
  "block.minecraft.banner.cross.gray": "Boz Çarpı",
  "block.minecraft.banner.cross.green": "Yaşıl Çarpı",
  "block.minecraft.banner.cross.light_blue": "Açıq Göy Çarpı",
  "block.minecraft.banner.cross.light_gray": "Açıq Boz Çarpı",
  "block.minecraft.banner.cross.lime": "Açıq Yaşıl Çarpı",
  "block.minecraft.banner.cross.magenta": "Magenta Çarpı",
  "block.minecraft.banner.cross.orange": "Narıncı Çarpı",
  "block.minecraft.banner.cross.pink": "Çəhrayı Çarpı",
  "block.minecraft.banner.cross.purple": "Bənövşəyi Çarpı",
  "block.minecraft.banner.cross.red": "Qırmızı Çarpı",
  "block.minecraft.banner.cross.white": "Ağ Çarpı",
  "block.minecraft.banner.cross.yellow": "Sarı Çarpı",
  "block.minecraft.banner.curly_border.black": "Qara Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.blue": "Göy Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.brown": "Qəhvəyi Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.cyan": "Mavi Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.gray": "Boz Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.green": "Yaşıl Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.light_blue": "Açıq Göy Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.light_gray": "Açıq Boz Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.lime": "Açıq Yaşıl Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.magenta": "Magenta Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.orange": "Narıncı Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.pink": "Çəhrayı Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.purple": "Bənövşəyi Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.red": "Qırmızı Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.white": "Ağ Mişar Dişi Çərçivə",
  "block.minecraft.banner.curly_border.yellow": "Sarı Mişar Dişi Çərçivə",
  "block.minecraft.banner.diagonal_left.black": "Qara Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.blue": "Göy Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.brown": "Qəhvəyi Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.cyan": "Mavi Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.gray": "Boz Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.green": "Yaşıl Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.light_blue": "Açıq Göy Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.light_gray": "Açıq Boz Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.lime": "Açıq Yaşıl Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.orange": "Narıncı Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.pink": "Çəhrayı Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.purple": "Bənövşəyi Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.red": "Qırmızı Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.white": "Ağ Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_left.yellow": "Sarı Sol Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.black": "Qara Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.blue": "Göy Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.brown": "Qəhvəyi Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.cyan": "Mavi Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.gray": "Boz Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.green": "Yaşıl Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.light_blue": "Açıq Göy Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.light_gray": "Açıq Boz Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.lime": "Açıq Yaşıl Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.orange": "Narıncı Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.pink": "Çəhrayı Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.purple": "Bənövşəyi Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.red": "Qırmızı Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.white": "Ağ Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_right.yellow": "Sarı Sağ Üst Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.black": "Qara Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.blue": "Göy Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.brown": "Qəhvəyi Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.cyan": "Mavi Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.gray": "Boz Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.green": "Yaşıl Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Açıq Göy Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Açıq Boz Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.lime": "Açıq Yaşıl Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.orange": "Narıncı Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.pink": "Çəhrayı Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.purple": "Bənövşəyi Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.red": "Qırmızı Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.white": "Ağ Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_left.yellow": "Sarı Sol Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.black": "Qara Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.blue": "Göy Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.brown": "Qəhvəyi Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.cyan": "Mavi Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.gray": "Boz Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.green": "Yaşıl Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Açıq Göy Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Açıq Boz Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.lime": "Açıq Yaşıl Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.orange": "Narıncı Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.pink": "Çəhrayı Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.purple": "Bənövşəyi Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.red": "Qırmızı Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.white": "Ağ Sağ Alt Üçbucaq",
  "block.minecraft.banner.diagonal_up_right.yellow": "Sarı Sağ Alt Üçbucaq",
  "block.minecraft.banner.flow.black": "Qara Axın",
  "block.minecraft.banner.flow.blue": "Mavi Axın",
  "block.minecraft.banner.flow.brown": "Qəhvəyi Axın",
  "block.minecraft.banner.flow.cyan": "Cyan Axın",
  "block.minecraft.banner.flow.gray": "Boz Axın",
  "block.minecraft.banner.flow.green": "Yaşıl Axın",
  "block.minecraft.banner.flow.light_blue": "Açıq Mavi Axın",
  "block.minecraft.banner.flow.light_gray": "Açıq Boz Axın",
  "block.minecraft.banner.flow.lime": "Açıq Yaşıl Axın",
  "block.minecraft.banner.flow.magenta": "Magenta Axın",
  "block.minecraft.banner.flow.orange": "Narıncı Axın",
  "block.minecraft.banner.flow.pink": "Çəhrayı Axın",
  "block.minecraft.banner.flow.purple": "Bənövşəyi Axın",
  "block.minecraft.banner.flow.red": "Qırmızı Axın",
  "block.minecraft.banner.flow.white": "Ağ Axın",
  "block.minecraft.banner.flow.yellow": "Sarı Axın",
  "block.minecraft.banner.flower.black": "Qara Çiçək Şəkli",
  "block.minecraft.banner.flower.blue": "Göy Çiçək Şəkli",
  "block.minecraft.banner.flower.brown": "Qəhvəyi Çiçək Şəkli",
  "block.minecraft.banner.flower.cyan": "Mavi Çiçək Şəkli",
  "block.minecraft.banner.flower.gray": "Boz Çiçək Şəkli",
  "block.minecraft.banner.flower.green": "Yaşıl Çiçək Şəkli",
  "block.minecraft.banner.flower.light_blue": "Açıq Göy Çiçək Şəkli",
  "block.minecraft.banner.flower.light_gray": "Açıq Boz Çiçək Şəkli",
  "block.minecraft.banner.flower.lime": "Açıq Yaşıl Çiçək Şəkli",
  "block.minecraft.banner.flower.magenta": "Magenta Çiçək Şəkli",
  "block.minecraft.banner.flower.orange": "Narıncı Çiçək Şəkli",
  "block.minecraft.banner.flower.pink": "Çəhrayı Çiçək Şəkli",
  "block.minecraft.banner.flower.purple": "Bənövşəyi Çiçək Şəkli",
  "block.minecraft.banner.flower.red": "Qırmızı Çiçək Şəkli",
  "block.minecraft.banner.flower.white": "Ağ Çiçək Şəkli",
  "block.minecraft.banner.flower.yellow": "Sarı Çiçək Şəkli",
  "block.minecraft.banner.globe.black": "Qara kürə",
  "block.minecraft.banner.globe.blue": "Göy kürə",
  "block.minecraft.banner.globe.brown": "Qəhvəyi kürə",
  "block.minecraft.banner.globe.cyan": "Zəngin cərimələr",
  "block.minecraft.banner.globe.gray": "Boz kürə",
  "block.minecraft.banner.globe.green": "Yaşıl kürə",
  "block.minecraft.banner.globe.light_blue": "Açıq Mavi Qlobus",
  "block.minecraft.banner.globe.light_gray": "Açıq-boz kürə",
  "block.minecraft.banner.globe.lime": "Əhəng kürəsi",
  "block.minecraft.banner.globe.magenta": "Bənövşəyi Qlobus",
  "block.minecraft.banner.globe.orange": "Narıncı kürə",
  "block.minecraft.banner.globe.pink": "Çəhrayı kürə",
  "block.minecraft.banner.globe.purple": "Bənövşəyi kürə",
  "block.minecraft.banner.globe.red": "Qırmızı qlobus",
  "block.minecraft.banner.globe.white": "Ağ kürə",
  "block.minecraft.banner.globe.yellow": "Sarı kürə",
  "block.minecraft.banner.gradient.black": "Yuxarıdan Aşağı Qara Keçiş",
  "block.minecraft.banner.gradient.blue": "Yuxarıdan Aşağı Göy Keçiş",
  "block.minecraft.banner.gradient.brown": "Yuxarıdan Aşağı Qəhvəyi Keçiş",
  "block.minecraft.banner.gradient.cyan": "Firuzəyi qradient",
  "block.minecraft.banner.gradient.gray": "Yuxarıdan Aşağı Boz Keçiş",
  "block.minecraft.banner.gradient.green": "Yuxarıdan Aşağı Yaşıl Keçiş",
  "block.minecraft.banner.gradient.light_blue": "Yuxarıdan Aşağı Açıq Göy Keçiş",
  "block.minecraft.banner.gradient.light_gray": "Yuxarıdan Aşağı Açıq Boz Keçiş",
  "block.minecraft.banner.gradient.lime": "Yuxarıdan Aşağı Açıq Yaşıl Keçiş",
  "block.minecraft.banner.gradient.magenta": "Macenta qradient",
  "block.minecraft.banner.gradient.orange": "Yuxarıdan Aşağı Narıncı Keçiş",
  "block.minecraft.banner.gradient.pink": "Yuxarıdan Aşağı Çəhrayı Keçiş",
  "block.minecraft.banner.gradient.purple": "Bənövşəyi qradient",
  "block.minecraft.banner.gradient.red": "Yuxarıdan Aşağı Qırmızı Keçiş",
  "block.minecraft.banner.gradient.white": "Yuxarıdan Aşağı Ağ Keçiş",
  "block.minecraft.banner.gradient.yellow": "Yuxarıdan Aşağı Sarı Keçiş",
  "block.minecraft.banner.gradient_up.black": "Aşağıdan Yuxarı Qara Keçiş",
  "block.minecraft.banner.gradient_up.blue": "Aşağıdan Yuxarı Göy Keçiş",
  "block.minecraft.banner.gradient_up.brown": "Aşağıdan Yuxarı Qəhvəyi Keçiş",
  "block.minecraft.banner.gradient_up.cyan": "Firuzəyi baza qradienti",
  "block.minecraft.banner.gradient_up.gray": "Aşağıdan Yuxarı Boz Keçiş",
  "block.minecraft.banner.gradient_up.green": "Aşağıdan Yuxarı Yaşıl Keçiş",
  "block.minecraft.banner.gradient_up.light_blue": "Aşağıdan Yuxarı Açıq Mavi Keçiş",
  "block.minecraft.banner.gradient_up.light_gray": "Aşağıdan Yuxarı Açıq Boz Keçiş",
  "block.minecraft.banner.gradient_up.lime": "Aşağıdan Yuxarı Açıq Yaşıl Keçiş",
  "block.minecraft.banner.gradient_up.magenta": "Aşağıdan Yuxarı Magenta Keçiş",
  "block.minecraft.banner.gradient_up.orange": "Aşağıdan Yuxarı Narıncı Keçiş",
  "block.minecraft.banner.gradient_up.pink": "Aşağıdan Yuxarı Çəhrayı Keçiş",
  "block.minecraft.banner.gradient_up.purple": "Bənövşəyi baza qradienti",
  "block.minecraft.banner.gradient_up.red": "Aşağıdan Yuxarı Qırmızı Keçiş",
  "block.minecraft.banner.gradient_up.white": "Aşağıdan Yuxarı Ağ Keçiş",
  "block.minecraft.banner.gradient_up.yellow": "Aşağıdan Yuxarı Sarı Keçiş",
  "block.minecraft.banner.guster.black": "Qara Fırtına",
  "block.minecraft.banner.guster.blue": "Mavi Fırtına",
  "block.minecraft.banner.guster.brown": "Qəhvəyi Fırtına",
  "block.minecraft.banner.guster.cyan": "Cyan Fırtına",
  "block.minecraft.banner.guster.gray": "Boz Leysan",
  "block.minecraft.banner.guster.green": "Yaşıl Leysan",
  "block.minecraft.banner.guster.light_blue": "Açıq Mavi Leysan",
  "block.minecraft.banner.guster.light_gray": "Açıq Boz Leysan",
  "block.minecraft.banner.guster.lime": "Əhəng tozu",
  "block.minecraft.banner.guster.magenta": "Magenta Leysan",
  "block.minecraft.banner.guster.orange": "Narıncı Leysan",
  "block.minecraft.banner.guster.pink": "Çəhrayı Leysan",
  "block.minecraft.banner.guster.purple": "Bənövşəyi Leysan",
  "block.minecraft.banner.guster.red": "Qırmızı Leysan",
  "block.minecraft.banner.guster.white": "Ağ Leysan",
  "block.minecraft.banner.guster.yellow": "Sarı Leysan",
  "block.minecraft.banner.half_horizontal.black": "Qara Üst Yarı",
  "block.minecraft.banner.half_horizontal.blue": "Göy Üst Yarı",
  "block.minecraft.banner.half_horizontal.brown": "Qəhvəyi Üst Yarı",
  "block.minecraft.banner.half_horizontal.cyan": "Mavi Üst Yarı",
  "block.minecraft.banner.half_horizontal.gray": "Boz Üst Yarı",
  "block.minecraft.banner.half_horizontal.green": "Yaşıl Üst Yarı",
  "block.minecraft.banner.half_horizontal.light_blue": "Açıq Göy Üst Yarı",
  "block.minecraft.banner.half_horizontal.light_gray": "Açıq Boz Üst Yarı",
  "block.minecraft.banner.half_horizontal.lime": "Açıq Yaşıl Üst Yarı",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Üst Yarı",
  "block.minecraft.banner.half_horizontal.orange": "Narıncı Üst Yarı",
  "block.minecraft.banner.half_horizontal.pink": "Çəhrayı Üst Yarı",
  "block.minecraft.banner.half_horizontal.purple": "Bənövşəyi Üst Yarı",
  "block.minecraft.banner.half_horizontal.red": "Qırmızı Üst Yarı",
  "block.minecraft.banner.half_horizontal.white": "Ağ Üst Yarı",
  "block.minecraft.banner.half_horizontal.yellow": "Sarı Üst Yarı",
  "block.minecraft.banner.half_horizontal_bottom.black": "Qara Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Göy Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Qəhvəyi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Mavi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Boz Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.green": "Yaşıl Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Açıq Göy Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Açıq Boz Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Açıq Yaşıl Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Narıncı Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Çəhrayı Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Bənövşəyi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.red": "Qırmızı Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ağ Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Sarı Alt Yarı",
  "block.minecraft.banner.half_vertical.black": "Qara Sol Yarı",
  "block.minecraft.banner.half_vertical.blue": "Göy Sol Yarı",
  "block.minecraft.banner.half_vertical.brown": "Qəhvəyi Sol Yarı",
  "block.minecraft.banner.half_vertical.cyan": "Mavi Sol Yarı",
  "block.minecraft.banner.half_vertical.gray": "Boz Sol Yarı",
  "block.minecraft.banner.half_vertical.green": "Yaşıl Sol Yarı",
  "block.minecraft.banner.half_vertical.light_blue": "Açıq Göy Sol Yarı",
  "block.minecraft.banner.half_vertical.light_gray": "Açıq Boz Sol Yarı",
  "block.minecraft.banner.half_vertical.lime": "Açıq Yaşıl Sol Yarı",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Sol Yarı",
  "block.minecraft.banner.half_vertical.orange": "Narıncı Sol Yarı",
  "block.minecraft.banner.half_vertical.pink": "Çəhrayı Sol Yarı",
  "block.minecraft.banner.half_vertical.purple": "Bənövşəyi Sol Yarı",
  "block.minecraft.banner.half_vertical.red": "Qırmızı Sol Yarı",
  "block.minecraft.banner.half_vertical.white": "Ağ Sol Yarı",
  "block.minecraft.banner.half_vertical.yellow": "Sarı Sol Yarı",
  "block.minecraft.banner.half_vertical_right.black": "Qara Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.blue": "Göy Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.brown": "Qəhvəyi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.cyan": "Mavi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.gray": "Boz Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.green": "Yaşıl Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.light_blue": "Açıq Göy Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.light_gray": "Açıq Boz Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.lime": "Açıq Yaşıl Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.orange": "Narıncı Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.pink": "Çəhrayı Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.purple": "Bənövşəyi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.red": "Qırmızı Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.white": "Ağ Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.yellow": "Sarı Sağ Yarı",
  "block.minecraft.banner.mojang.black": "Qara Şey",
  "block.minecraft.banner.mojang.blue": "Göy Şey",
  "block.minecraft.banner.mojang.brown": "Qəhvəyi Şey",
  "block.minecraft.banner.mojang.cyan": "Mavi Şey",
  "block.minecraft.banner.mojang.gray": "Boz Şey",
  "block.minecraft.banner.mojang.green": "Yaşıl Şey",
  "block.minecraft.banner.mojang.light_blue": "Açıq Göy Şey",
  "block.minecraft.banner.mojang.light_gray": "Açıq Boz Şey",
  "block.minecraft.banner.mojang.lime": "Açıq Yaşıl Şey",
  "block.minecraft.banner.mojang.magenta": "Magenta Şey",
  "block.minecraft.banner.mojang.orange": "Narıncı Şey",
  "block.minecraft.banner.mojang.pink": "Çəhrayı Şey",
  "block.minecraft.banner.mojang.purple": "Bənövşəyi Şey",
  "block.minecraft.banner.mojang.red": "Qırmızı Şey",
  "block.minecraft.banner.mojang.white": "Ağ Şey",
  "block.minecraft.banner.mojang.yellow": "Sarı Şey",
  "block.minecraft.banner.piglin.black": "Qara Burun",
  "block.minecraft.banner.piglin.blue": "Mavi burun",
  "block.minecraft.banner.piglin.brown": "Qəhvəyi burun",
  "block.minecraft.banner.piglin.cyan": "Tünd mavi burun",
  "block.minecraft.banner.piglin.gray": "Boz burun",
  "block.minecraft.banner.piglin.green": "Yaşıl burun",
  "block.minecraft.banner.piglin.light_blue": "Açıq mavi burun",
  "block.minecraft.banner.piglin.light_gray": "Açıq boz burun",
  "block.minecraft.banner.piglin.lime": "Əhəng burun",
  "block.minecraft.banner.piglin.magenta": "Əflatun Donuz Burnu",
  "block.minecraft.banner.piglin.orange": "Narıncı burun",
  "block.minecraft.banner.piglin.pink": "Çəhrayı burun",
  "block.minecraft.banner.piglin.purple": "Bənövşəyi burun",
  "block.minecraft.banner.piglin.red": "Qırmızı burun",
  "block.minecraft.banner.piglin.white": "Ağ burun",
  "block.minecraft.banner.piglin.yellow": "Sarı burun",
  "block.minecraft.banner.rhombus.black": "Qara Romb",
  "block.minecraft.banner.rhombus.blue": "Göy Romb",
  "block.minecraft.banner.rhombus.brown": "Qəhvəyi Romb",
  "block.minecraft.banner.rhombus.cyan": "Mavi Romb",
  "block.minecraft.banner.rhombus.gray": "Boz Romb",
  "block.minecraft.banner.rhombus.green": "Yaşıl Romb",
  "block.minecraft.banner.rhombus.light_blue": "Açıq Göy Romb",
  "block.minecraft.banner.rhombus.light_gray": "Açıq Boz Romb",
  "block.minecraft.banner.rhombus.lime": "Açıq Yaşıl Romb",
  "block.minecraft.banner.rhombus.magenta": "Magenta Romb",
  "block.minecraft.banner.rhombus.orange": "Narıncı Romb",
  "block.minecraft.banner.rhombus.pink": "Çəhrayı Romb",
  "block.minecraft.banner.rhombus.purple": "Bənövşəyi Romb",
  "block.minecraft.banner.rhombus.red": "Qırmızı Romb",
  "block.minecraft.banner.rhombus.white": "Ağ Romb",
  "block.minecraft.banner.rhombus.yellow": "Sarı Romb",
  "block.minecraft.banner.skull.black": "Qara Quru Baş Şəkli",
  "block.minecraft.banner.skull.blue": "Göy Quru Baş Şəkli",
  "block.minecraft.banner.skull.brown": "Qəhvəyi Quru Baş Şəkli",
  "block.minecraft.banner.skull.cyan": "Mavi Quru Baş Şəkli",
  "block.minecraft.banner.skull.gray": "Boz Quru Baş Şəkli",
  "block.minecraft.banner.skull.green": "Yaşıl Quru Baş Şəkli",
  "block.minecraft.banner.skull.light_blue": "Açıq Göy Quru Baş Şəkli",
  "block.minecraft.banner.skull.light_gray": "Açıq Boz Quru Baş Şəkli",
  "block.minecraft.banner.skull.lime": "Açıq Yaşıl Quru Baş Şəkli",
  "block.minecraft.banner.skull.magenta": "Magenta Quru Baş Şəkli",
  "block.minecraft.banner.skull.orange": "Narıncı Quru Baş Şəkli",
  "block.minecraft.banner.skull.pink": "Çəhrayı Quru Baş Şəkli",
  "block.minecraft.banner.skull.purple": "Bənövşəyi Quru Baş Şəkli",
  "block.minecraft.banner.skull.red": "Qırmızı Quru Baş Şəkli",
  "block.minecraft.banner.skull.white": "Ağ Quru Baş Şəkli",
  "block.minecraft.banner.skull.yellow": "Sarı Quru Baş Şəkli",
  "block.minecraft.banner.small_stripes.black": "Qara İncə Sütunlar",
  "block.minecraft.banner.small_stripes.blue": "Göy İncə Sütunlar",
  "block.minecraft.banner.small_stripes.brown": "Qəhvəyi İncə Sütunlar",
  "block.minecraft.banner.small_stripes.cyan": "Mavi İncə Sütunlar",
  "block.minecraft.banner.small_stripes.gray": "Boz İncə Sütunlar",
  "block.minecraft.banner.small_stripes.green": "Yaşıl İncə Sütunlar",
  "block.minecraft.banner.small_stripes.light_blue": "Açıq Göy İncə Sütunlar",
  "block.minecraft.banner.small_stripes.light_gray": "Açıq Boz İncə Sütunlar",
  "block.minecraft.banner.small_stripes.lime": "Açıq Yaşıl İncə Sütunlar",
  "block.minecraft.banner.small_stripes.magenta": "Magenta İncə Sütunlar",
  "block.minecraft.banner.small_stripes.orange": "Narıncı İncə Sütunlar",
  "block.minecraft.banner.small_stripes.pink": "Çəhrayı İncə Sütunlar",
  "block.minecraft.banner.small_stripes.purple": "Bənövşəyi İncə Sütunlar",
  "block.minecraft.banner.small_stripes.red": "Qırmızı İncə Sütunlar",
  "block.minecraft.banner.small_stripes.white": "Ağ İncə Sütunlar",
  "block.minecraft.banner.small_stripes.yellow": "Sarı İncə Sütunlar",
  "block.minecraft.banner.square_bottom_left.black": "Qara Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.blue": "Göy Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.brown": "Qəhvəyi Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.cyan": "Mavi Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.gray": "Boz Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.green": "Yaşıl Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.light_blue": "Açıq Göy Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.light_gray": "Açıq Boz Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.lime": "Açıq Yaşıl Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.orange": "Narıncı Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.pink": "Çəhrayı Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.purple": "Bənövşəyi Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.red": "Qırmızı Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.white": "Ağ Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_left.yellow": "Sarı Sol Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.black": "Qara Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.blue": "Göy Sağ Alt Düzbucaqlı",
  "block.minecraft.banner.square_bottom_right.brown": "Qəhvəyi Sağ Alt Düzbucaqlı",
  "block.minecraft.banner.square_bottom_right.cyan": "Mavi Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.gray": "Boz Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.green": "Yaşıl Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.light_blue": "Açıq Göy Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.light_gray": "Açıq Boz Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.lime": "Açıq Yaşıl Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.orange": "Narıncı Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.pink": "Çəhrayı Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.purple": "Bənövşəyi Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.red": "Qırmızı Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.white": "Ağ Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_bottom_right.yellow": "Sarı Sağ Alt Dördbucaq",
  "block.minecraft.banner.square_top_left.black": "Qara Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.blue": "Göy Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.brown": "Qəhvəyi Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.cyan": "Mavi Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.gray": "Boz Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.green": "Yaşıl Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.light_blue": "Açıq Göy Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.light_gray": "Açıq Boz Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.lime": "Açıq Yaşıl Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.magenta": "Magenta Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.orange": "Narıncı Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.pink": "Çəhrayı Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.purple": "Bənövşəyi Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.red": "Qırmızı Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.white": "Ağ Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_left.yellow": "Sarı Sol Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.black": "Qara Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.blue": "Göy Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.brown": "Qəhvəyi Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.cyan": "Mavi Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.gray": "Boz Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.green": "Yaşıl Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.light_blue": "Açıq Göy Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.light_gray": "Açıq Boz Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.lime": "Açıq Yaşıl Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.orange": "Narıncı Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.pink": "Çəhrayı Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.purple": "Bənövşəyi Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.red": "Qırmızı Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.white": "Ağ Sağ Üst Dördbucaq",
  "block.minecraft.banner.square_top_right.yellow": "Sarı Sağ Üst Dördbucaq",
  "block.minecraft.banner.straight_cross.black": "Qara Xaç",
  "block.minecraft.banner.straight_cross.blue": "Göy Xaç",
  "block.minecraft.banner.straight_cross.brown": "Qəhvəyi Xaç",
  "block.minecraft.banner.straight_cross.cyan": "Mavi Xaç",
  "block.minecraft.banner.straight_cross.gray": "Boz Xaç",
  "block.minecraft.banner.straight_cross.green": "Yaşıl Xaç",
  "block.minecraft.banner.straight_cross.light_blue": "Açıq Göy Xaç",
  "block.minecraft.banner.straight_cross.light_gray": "Açıq Boz Xaç",
  "block.minecraft.banner.straight_cross.lime": "Açıq Yaşıl Xaç",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Xaç",
  "block.minecraft.banner.straight_cross.orange": "Narıncı Xaç",
  "block.minecraft.banner.straight_cross.pink": "Çəhrayı Xaç",
  "block.minecraft.banner.straight_cross.purple": "Bənövşəyi Xaç",
  "block.minecraft.banner.straight_cross.red": "Qırmızı Xaç",
  "block.minecraft.banner.straight_cross.white": "Ağ Xaç",
  "block.minecraft.banner.straight_cross.yellow": "Sarı Xaç",
  "block.minecraft.banner.stripe_bottom.black": "Altdan Qara Sətir",
  "block.minecraft.banner.stripe_bottom.blue": "Altdan Göy Sətir",
  "block.minecraft.banner.stripe_bottom.brown": "Altdan Qəhvəyi Sətir",
  "block.minecraft.banner.stripe_bottom.cyan": "Altdan Mavi Sətir",
  "block.minecraft.banner.stripe_bottom.gray": "Altdan Boz Sətir",
  "block.minecraft.banner.stripe_bottom.green": "Altdan Yaşıl Sətir",
  "block.minecraft.banner.stripe_bottom.light_blue": "Altdan Açıq Göy Sətir",
  "block.minecraft.banner.stripe_bottom.light_gray": "Altdan Açıq Boz Sətir",
  "block.minecraft.banner.stripe_bottom.lime": "Altdan Açıq Yaşıl Sətir",
  "block.minecraft.banner.stripe_bottom.magenta": "Altdan Magenta Sətir",
  "block.minecraft.banner.stripe_bottom.orange": "Altdan Narıncı Sətir",
  "block.minecraft.banner.stripe_bottom.pink": "Altdan Çəhrayı Sətir",
  "block.minecraft.banner.stripe_bottom.purple": "Altdan Bənövşəyi Sətir",
  "block.minecraft.banner.stripe_bottom.red": "Altdan Qırmızı Sətir",
  "block.minecraft.banner.stripe_bottom.white": "Altdan Ağ Sətir",
  "block.minecraft.banner.stripe_bottom.yellow": "Altdan Sarı Sətir",
  "block.minecraft.banner.stripe_center.black": "Ortadan Qara Sütun",
  "block.minecraft.banner.stripe_center.blue": "Ortadan Göy Sütun",
  "block.minecraft.banner.stripe_center.brown": "Ortadan Qəhvəyi Sütun",
  "block.minecraft.banner.stripe_center.cyan": "Ortadan Mavi Sütun",
  "block.minecraft.banner.stripe_center.gray": "Ortadan Boz Sütun",
  "block.minecraft.banner.stripe_center.green": "Ortadan Yaşıl Sütun",
  "block.minecraft.banner.stripe_center.light_blue": "Ortadan Açıq Göy Sütun",
  "block.minecraft.banner.stripe_center.light_gray": "Ortadan Açıq Boz Sütun",
  "block.minecraft.banner.stripe_center.lime": "Ortadan Açıq Yaşıl Sütun",
  "block.minecraft.banner.stripe_center.magenta": "Ortadan Magenta Sütun",
  "block.minecraft.banner.stripe_center.orange": "Ortadan Narıncı Sütun",
  "block.minecraft.banner.stripe_center.pink": "Ortadan Çəhrayı Sütun",
  "block.minecraft.banner.stripe_center.purple": "Ortadan Bənövşəyi Sütun",
  "block.minecraft.banner.stripe_center.red": "Ortadan Qırmızı Sütun",
  "block.minecraft.banner.stripe_center.white": "Ortadan Ağ Sütun",
  "block.minecraft.banner.stripe_center.yellow": "Ortadan Sarı Sütun",
  "block.minecraft.banner.stripe_downleft.black": "Qara Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.blue": "Göy Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.brown": "Qəhvəyi Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.cyan": "Mavi Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.gray": "Boz Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.green": "Yaşıl Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.light_blue": "Açıq Göy Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.light_gray": "Açıq Boz Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.lime": "Açıq Yaşıl Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.orange": "Narıncı Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.pink": "Çəhrayı Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.purple": "Bənövşəyi Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.red": "Qırmızı Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.white": "Ağ Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downleft.yellow": "Sarı Tərs Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.black": "Qara Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.blue": "Göy Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.brown": "Qəhvəyi Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.cyan": "Mavi Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.gray": "Boz Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.green": "Yaşıl Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.light_blue": "Açıq Göy Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.light_gray": "Açıq Boz Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.lime": "Açıq Yaşıl Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.orange": "Narıncı Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.pink": "Çəhrayı Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.purple": "Bənövşəyi Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.red": "Qırmızı Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.white": "Ağ Çarpaz Lent",
  "block.minecraft.banner.stripe_downright.yellow": "Sarı Çarpaz Lent",
  "block.minecraft.banner.stripe_left.black": "Soldan Qara Sütun",
  "block.minecraft.banner.stripe_left.blue": "Soldan Göy Sütun",
  "block.minecraft.banner.stripe_left.brown": "Soldan Qəhvəyi Sütun",
  "block.minecraft.banner.stripe_left.cyan": "Soldan Mavi Sütun",
  "block.minecraft.banner.stripe_left.gray": "Soldan Boz Sütun",
  "block.minecraft.banner.stripe_left.green": "Soldan Yaşıl Sütun",
  "block.minecraft.banner.stripe_left.light_blue": "Soldan Açıq Göy Sütun",
  "block.minecraft.banner.stripe_left.light_gray": "Soldan Açıq Boz Sütun",
  "block.minecraft.banner.stripe_left.lime": "Soldan Açıq Yaşıl Sütun",
  "block.minecraft.banner.stripe_left.magenta": "Soldan Magenta Sütun",
  "block.minecraft.banner.stripe_left.orange": "Soldan Narıncı Sütun",
  "block.minecraft.banner.stripe_left.pink": "Soldan Çəhrayı Sütun",
  "block.minecraft.banner.stripe_left.purple": "Soldan Bənövşəyi Sütun",
  "block.minecraft.banner.stripe_left.red": "Soldan Qırmızı Sütun",
  "block.minecraft.banner.stripe_left.white": "Soldan Ağ Sütun",
  "block.minecraft.banner.stripe_left.yellow": "Soldan Sarı Sütun",
  "block.minecraft.banner.stripe_middle.black": "Ortadan Qara Sətir",
  "block.minecraft.banner.stripe_middle.blue": "Ortadan Göy Sətir",
  "block.minecraft.banner.stripe_middle.brown": "Ortadan Qəhvəyi Sətir",
  "block.minecraft.banner.stripe_middle.cyan": "Ortadan Mavi Sətir",
  "block.minecraft.banner.stripe_middle.gray": "Ortadan Boz Sətir",
  "block.minecraft.banner.stripe_middle.green": "Ortadan Yaşıl Sətir",
  "block.minecraft.banner.stripe_middle.light_blue": "Ortadan Açıq Göy Sətir",
  "block.minecraft.banner.stripe_middle.light_gray": "Ortadan Açıq Boz Sətir",
  "block.minecraft.banner.stripe_middle.lime": "Ortadan Açıq Yaşıl Sətir",
  "block.minecraft.banner.stripe_middle.magenta": "Ortadan Magenta Sətir",
  "block.minecraft.banner.stripe_middle.orange": "Ortadan Narıncı Sətir",
  "block.minecraft.banner.stripe_middle.pink": "Ortadan Çəhrayı Sətir",
  "block.minecraft.banner.stripe_middle.purple": "Ortadan Bənövşəyi Sətir",
  "block.minecraft.banner.stripe_middle.red": "Ortadan Qırmızı Sətir",
  "block.minecraft.banner.stripe_middle.white": "Ortadan Ağ Sətir",
  "block.minecraft.banner.stripe_middle.yellow": "Ortadan Sarı Sətir",
  "block.minecraft.banner.stripe_right.black": "Sağdan Qara Sütun",
  "block.minecraft.banner.stripe_right.blue": "Sağdan Göy Sütun",
  "block.minecraft.banner.stripe_right.brown": "Sağdan Qəhvəyi Sütun",
  "block.minecraft.banner.stripe_right.cyan": "Sağdan Mavi Sütun",
  "block.minecraft.banner.stripe_right.gray": "Sağdan Boz Sütun",
  "block.minecraft.banner.stripe_right.green": "Sağdan Yaşıl Sütun",
  "block.minecraft.banner.stripe_right.light_blue": "Sağdan Açıq Göy Sütun",
  "block.minecraft.banner.stripe_right.light_gray": "Sağdan Açıq Boz Sütun",
  "block.minecraft.banner.stripe_right.lime": "Sağdan Açıq Yaşıl Sütun",
  "block.minecraft.banner.stripe_right.magenta": "Sağdan Magenta Sütun",
  "block.minecraft.banner.stripe_right.orange": "Sağdan Narıncı Sütun",
  "block.minecraft.banner.stripe_right.pink": "Sağdan Çəhrayı Sütun",
  "block.minecraft.banner.stripe_right.purple": "Sağdan Bənövşəyi Sütun",
  "block.minecraft.banner.stripe_right.red": "Sağdan Qırmızı Sütun",
  "block.minecraft.banner.stripe_right.white": "Sağdan Ağ Sütun",
  "block.minecraft.banner.stripe_right.yellow": "Sağdan Sarı Sütun",
  "block.minecraft.banner.stripe_top.black": "Üstdən Qara Sətir",
  "block.minecraft.banner.stripe_top.blue": "Üstdən Göy Sətir",
  "block.minecraft.banner.stripe_top.brown": "Üstdən Qəhvəyi Sətir",
  "block.minecraft.banner.stripe_top.cyan": "Üstdən Mavi Sətir",
  "block.minecraft.banner.stripe_top.gray": "Üstdən Boz Sətir",
  "block.minecraft.banner.stripe_top.green": "Üstdən Yaşıl Sətir",
  "block.minecraft.banner.stripe_top.light_blue": "Üstdən Açıq Göy Sətir",
  "block.minecraft.banner.stripe_top.light_gray": "Üstdən Açıq Boz Sətir",
  "block.minecraft.banner.stripe_top.lime": "Üstdən Açıq Yaşıl Sətir",
  "block.minecraft.banner.stripe_top.magenta": "Üstdən Magenta Sətir",
  "block.minecraft.banner.stripe_top.orange": "Üstdən Narıncı Sətir",
  "block.minecraft.banner.stripe_top.pink": "Üstdən Çəhrayı Sətir",
  "block.minecraft.banner.stripe_top.purple": "Üstdən Bənövşəyi Sətir",
  "block.minecraft.banner.stripe_top.red": "Üstdən Qırmızı Sətir",
  "block.minecraft.banner.stripe_top.white": "Üstdən Ağ Sətir",
  "block.minecraft.banner.stripe_top.yellow": "Üstdən Sarı Sətir",
  "block.minecraft.banner.triangle_bottom.black": "Altdan Qara Üçbucaq",
  "block.minecraft.banner.triangle_bottom.blue": "Altdan Göy Üçbucaq",
  "block.minecraft.banner.triangle_bottom.brown": "Altdan Qəhvəyi Üçbucaq",
  "block.minecraft.banner.triangle_bottom.cyan": "Altdan Mavi Üçbucaq",
  "block.minecraft.banner.triangle_bottom.gray": "Altdan Boz Üçbucaq",
  "block.minecraft.banner.triangle_bottom.green": "Altdan Yaşıl Üçbucaq",
  "block.minecraft.banner.triangle_bottom.light_blue": "Altdan Açıq Göy Üçbucaq",
  "block.minecraft.banner.triangle_bottom.light_gray": "Altdan Açıq Boz Üçbucaq",
  "block.minecraft.banner.triangle_bottom.lime": "Altdan Açıq Yaşıl Üçbucaq",
  "block.minecraft.banner.triangle_bottom.magenta": "Altdan Magenta Üçbucaq",
  "block.minecraft.banner.triangle_bottom.orange": "Altdan Narıncı Üçbucaq",
  "block.minecraft.banner.triangle_bottom.pink": "Altdan Çəhrayı Üçbucaq",
  "block.minecraft.banner.triangle_bottom.purple": "Altdan Bənövşəyi Üçbucaq",
  "block.minecraft.banner.triangle_bottom.red": "Altdan Qırmızı Üçbucaq",
  "block.minecraft.banner.triangle_bottom.white": "Altdan Ağ Üçbucaq",
  "block.minecraft.banner.triangle_bottom.yellow": "Altdan Sarı Üçbucaq",
  "block.minecraft.banner.triangle_top.black": "Üstdən Qara Üçbucaq",
  "block.minecraft.banner.triangle_top.blue": "Üstdən Göy Üçbucaq",
  "block.minecraft.banner.triangle_top.brown": "Üstdən Qəhvəyi Üçbucaq",
  "block.minecraft.banner.triangle_top.cyan": "Üstdən Mavi Üçbucaq",
  "block.minecraft.banner.triangle_top.gray": "Üstdən Boz Üçbucaq",
  "block.minecraft.banner.triangle_top.green": "Üstdən Yaşıl Üçbucaq",
  "block.minecraft.banner.triangle_top.light_blue": "Üstdən Açıq Göy Üçbucaq",
  "block.minecraft.banner.triangle_top.light_gray": "Üstdən Açıq Boz Üçbucaq",
  "block.minecraft.banner.triangle_top.lime": "Üstdən Açıq Yaşıl Üçbucaq",
  "block.minecraft.banner.triangle_top.magenta": "Üstdən Magenta Üçbucaq",
  "block.minecraft.banner.triangle_top.orange": "Üstdən Narıncı Üçbucaq",
  "block.minecraft.banner.triangle_top.pink": "Üstdən Çəhrayı Üçbucaq",
  "block.minecraft.banner.triangle_top.purple": "Üstdən Bənövşəyi Üçbucaq",
  "block.minecraft.banner.triangle_top.red": "Üstdən Qırmızı Üçbucaq",
  "block.minecraft.banner.triangle_top.white": "Üstdən Ağ Üçbucaq",
  "block.minecraft.banner.triangle_top.yellow": "Üstdən Sarı Üçbucaq",
  "block.minecraft.banner.triangles_bottom.black": "Altdan Qara Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.blue": "Altdan Göy Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.brown": "Altdan Qəhvəyi Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.cyan": "Altdan Mavi Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.gray": "Altdan Boz Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.green": "Altdan Yaşıl Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.light_blue": "Altdan Açıq Göy Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.light_gray": "Altdan Açıq Boz Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.lime": "Altdan Açıq Yaşıl Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.magenta": "Altdan Magenta Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.orange": "Altdan Narıncı Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.pink": "Altdan Çəhrayı Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.purple": "Altdan Bənövşəyi Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.red": "Altdan Qırmızı Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.white": "Altdan Ağ Yaşıl Mişar Dişi",
  "block.minecraft.banner.triangles_bottom.yellow": "Altdan Sarı Mişar Dişi",
  "block.minecraft.banner.triangles_top.black": "Üstdən Qara Mişar Dişi",
  "block.minecraft.banner.triangles_top.blue": "Üstdən Göy Mişar Dişi",
  "block.minecraft.banner.triangles_top.brown": "Üstdən Qəhvəyi Mişar Dişi",
  "block.minecraft.banner.triangles_top.cyan": "Üstdən Mavi Mişar Dişi",
  "block.minecraft.banner.triangles_top.gray": "Üstdən Boz Mişar Dişi",
  "block.minecraft.banner.triangles_top.green": "Üstdən Yaşıl Mişar Dişi",
  "block.minecraft.banner.triangles_top.light_blue": "Üstdən Açıq Göy Mişar Dişi",
  "block.minecraft.banner.triangles_top.light_gray": "Üstdən Açıq Boz Mişar Dişi",
  "block.minecraft.banner.triangles_top.lime": "Üstdən Açıq Yaşıl Mişar Dişi",
  "block.minecraft.banner.triangles_top.magenta": "Üstdən Magenta Mişar Dişi",
  "block.minecraft.banner.triangles_top.orange": "Üstdən Narıncı Mişar Dişi",
  "block.minecraft.banner.triangles_top.pink": "Üstdən Çəhrayı Mişar Dişi",
  "block.minecraft.banner.triangles_top.purple": "Üstdən Bənövşəyi Mişar Dişi",
  "block.minecraft.banner.triangles_top.red": "Üstdən Qırmızı Mişar Dişi",
  "block.minecraft.banner.triangles_top.white": "Üstdən Ağ Mişar Dişi",
  "block.minecraft.banner.triangles_top.yellow": "Üstdən Sarı Mişar Dişi",
  "block.minecraft.barrel": "Çəllək",
  "block.minecraft.barrier": "Baryer",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Mayak",
  "block.minecraft.beacon.primary": "Birincil Güc",
  "block.minecraft.beacon.secondary": "İkincil Güc",
  "block.minecraft.bed.no_sleep": "Yalnız gecə və ya tufan zamanı yata bilərsiniz",
  "block.minecraft.bed.not_safe": "İndi dincələ bilməzsiniz; yaxınlıqda monsterlər var",
  "block.minecraft.bed.obstructed": "Bu çarpayı doludur",
  "block.minecraft.bed.occupied": "Bu çarpayı dolu",
  "block.minecraft.bed.too_far_away": "İndi dincələ bilməzsən; çarpayı çox uzaqdadır",
  "block.minecraft.bedrock": "Təbəqə Qayası",
  "block.minecraft.bee_nest": "Arı Yuvası",
  "block.minecraft.beehive": "Arı Pətəyi",
  "block.minecraft.beetroots": "Çuğundurlar",
  "block.minecraft.bell": "Zəng",
  "block.minecraft.big_dripleaf": "Böyük damcıyarpaq",
  "block.minecraft.big_dripleaf_stem": "Böyük damcıyarpaq saplağı",
  "block.minecraft.birch_button": "Ağcaqayın Düymə",
  "block.minecraft.birch_door": "Ağcaqayın Qapı",
  "block.minecraft.birch_fence": "Ağcaqayın Çəpər",
  "block.minecraft.birch_fence_gate": "Ağcaqayın Çəpər Qapısı",
  "block.minecraft.birch_hanging_sign": "Ağcaqayın Asma İşarəsi",
  "block.minecraft.birch_leaves": "Ağcaqayın Yarpaqları",
  "block.minecraft.birch_log": "Ağcaqayın kötüyü",
  "block.minecraft.birch_planks": "Ağcaqayın Taxta",
  "block.minecraft.birch_pressure_plate": "Ağcaqayın Təyziq Təbəqəsi",
  "block.minecraft.birch_sapling": "Ağcaqayın Fidanı",
  "block.minecraft.birch_shelf": "Ağcaqayın rəfi",
  "block.minecraft.birch_sign": "Ağcaqayın Lövhə",
  "block.minecraft.birch_slab": "Ağcaqayın Pillə",
  "block.minecraft.birch_stairs": "Ağcaqayın Pilləkən",
  "block.minecraft.birch_trapdoor": "Ağcaqayın Tələ Qapısı",
  "block.minecraft.birch_wall_hanging_sign": "Ağcaqayın Divardan Asma İşarəsi",
  "block.minecraft.birch_wall_sign": "Divarda Ağcaqayın Lövhə",
  "block.minecraft.birch_wood": "Ağcaqayın Odunu",
  "block.minecraft.black_banner": "Qara Bayraq",
  "block.minecraft.black_bed": "Qara Çarpayı",
  "block.minecraft.black_candle": "Qara Şam",
  "block.minecraft.black_candle_cake": "Qara şamlı tort",
  "block.minecraft.black_carpet": "Qara Xalça",
  "block.minecraft.black_concrete": "Qara Beton",
  "block.minecraft.black_concrete_powder": "Qara Sement",
  "block.minecraft.black_glazed_terracotta": "Qara Şirli Terrakotta",
  "block.minecraft.black_shulker_box": "Qara Shulker Qutusu",
  "block.minecraft.black_stained_glass": "Qara Rəngli Şüşə",
  "block.minecraft.black_stained_glass_pane": "Qara Rəngli İncə Şüşə",
  "block.minecraft.black_terracotta": "Qara Terrakotta",
  "block.minecraft.black_wool": "Qara Yun",
  "block.minecraft.blackstone": "Qaradaş",
  "block.minecraft.blackstone_slab": "Qaradaş pilləsi",
  "block.minecraft.blackstone_stairs": "Qaradaş pilləkən",
  "block.minecraft.blackstone_wall": "Qaradaş divar",
  "block.minecraft.blast_furnace": "Mədən Sobası",
  "block.minecraft.blue_banner": "Göy Bayraq",
  "block.minecraft.blue_bed": "Göy Çarpayı",
  "block.minecraft.blue_candle": "Göy Şam",
  "block.minecraft.blue_candle_cake": "Göy şamlı tort",
  "block.minecraft.blue_carpet": "Göy Xalça",
  "block.minecraft.blue_concrete": "Göy Beton",
  "block.minecraft.blue_concrete_powder": "Göy Sement",
  "block.minecraft.blue_glazed_terracotta": "Göy Şirli Terrakotta",
  "block.minecraft.blue_ice": "Göy Buz",
  "block.minecraft.blue_orchid": "Göy Orkide",
  "block.minecraft.blue_shulker_box": "Göy Shulker Qutusu",
  "block.minecraft.blue_stained_glass": "Göy Rəngli Şüşə",
  "block.minecraft.blue_stained_glass_pane": "Göy Rəngli İncə Şüşə",
  "block.minecraft.blue_terracotta": "Göy terrakotta",
  "block.minecraft.blue_wool": "Göy Yun",
  "block.minecraft.bone_block": "Sümük Bloku",
  "block.minecraft.bookshelf": "Kitab Rəfi",
  "block.minecraft.brain_coral": "Beyin mərcan",
  "block.minecraft.brain_coral_block": "Beyin mərcan bloku",
  "block.minecraft.brain_coral_fan": "Beyin mərcan",
  "block.minecraft.brain_coral_wall_fan": " Üfüqi mərcan divarı",
  "block.minecraft.brewing_stand": "Eliksir Dəzgahı",
  "block.minecraft.brick_slab": "Kərpic Pillə",
  "block.minecraft.brick_stairs": "Kərpic Pilləkən",
  "block.minecraft.brick_wall": "Kərpic divar",
  "block.minecraft.bricks": "Kərpic",
  "block.minecraft.brown_banner": "Qəhvəyi Bayraq",
  "block.minecraft.brown_bed": "Qəhvəyi Çarpayı",
  "block.minecraft.brown_candle": "Qəhvəyi Şam",
  "block.minecraft.brown_candle_cake": "Qəhvəyi şamlı tort",
  "block.minecraft.brown_carpet": "Qəhvəyi Xalça",
  "block.minecraft.brown_concrete": "Qəhvəyi Beton",
  "block.minecraft.brown_concrete_powder": "Qəhvəyi Sement",
  "block.minecraft.brown_glazed_terracotta": "Qəhvəyi Şirli Terrakotta",
  "block.minecraft.brown_mushroom": "Qəhvəyi Göbələk",
  "block.minecraft.brown_mushroom_block": "Qəhvəyi Göbələk Bloku",
  "block.minecraft.brown_shulker_box": "Qəhvəyi Shulker Qutusu",
  "block.minecraft.brown_stained_glass": "Qəhvəyi Rəngli Şüşə",
  "block.minecraft.brown_stained_glass_pane": "Qəhvəyi Rəngli İncə Şüşə",
  "block.minecraft.brown_terracotta": "Qəhvəyi Terrakotta",
  "block.minecraft.brown_wool": "Qəhvəyi Yun",
  "block.minecraft.bubble_column": "Baloncuk Sütunu",
  "block.minecraft.bubble_coral": "Baloncuk mərcan",
  "block.minecraft.bubble_coral_block": "Baloncuk mərcan bloku",
  "block.minecraft.bubble_coral_fan": "Bubble Coral Fan",
  "block.minecraft.bubble_coral_wall_fan": "Köpük mərcan dıvarı",
  "block.minecraft.budding_amethyst": "Tumurcuqlanan ametist",
  "block.minecraft.bush": "Kol",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktus Gülü",
  "block.minecraft.cake": "Tort",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrlənmiş Sculk Sensor",
  "block.minecraft.campfire": "Düşərgə tonqalı",
  "block.minecraft.candle": "Şam",
  "block.minecraft.candle_cake": "Şamlı Tort",
  "block.minecraft.carrots": "Yerkökülər",
  "block.minecraft.cartography_table": "Xəriteçi Masası",
  "block.minecraft.carved_pumpkin": "Oyulmuş balqabaq",
  "block.minecraft.cauldron": "Qazan",
  "block.minecraft.cave_air": "Mağara Havası",
  "block.minecraft.cave_vines": "Mağara sarmaşıqları",
  "block.minecraft.cave_vines_plant": "Mağara sarmaşığı bitkisi",
  "block.minecraft.chain": "Zəncir",
  "block.minecraft.chain_command_block": "Zəncirləmə Əmr Bloku",
  "block.minecraft.cherry_button": "Albalı düyməsi",
  "block.minecraft.cherry_door": "Albalı Qapı",
  "block.minecraft.cherry_fence": "Albalı Çəpər",
  "block.minecraft.cherry_fence_gate": "Albalı hasar qapısı",
  "block.minecraft.cherry_hanging_sign": "Albalı Asma İşarəsi",
  "block.minecraft.cherry_leaves": "Albalı yarpaqları",
  "block.minecraft.cherry_log": "Albalı Girişi",
  "block.minecraft.cherry_planks": "Albalı taxtaları",
  "block.minecraft.cherry_pressure_plate": "Albalı təzyiq lövhəsi",
  "block.minecraft.cherry_sapling": "Albalı Fidanı",
  "block.minecraft.cherry_shelf": "Albalı rəfi",
  "block.minecraft.cherry_sign": "Albalı işarəsi",
  "block.minecraft.cherry_slab": "Albalı Plitəsi",
  "block.minecraft.cherry_stairs": "Albalı pilləkənləri",
  "block.minecraft.cherry_trapdoor": "Albalı tələ qapısı",
  "block.minecraft.cherry_wall_hanging_sign": "Albalı Divardan Asma Nişanı",
  "block.minecraft.cherry_wall_sign": "Albalı Divar İşarəsi",
  "block.minecraft.cherry_wood": "Albalı ağacı",
  "block.minecraft.chest": "Sandıq",
  "block.minecraft.chipped_anvil": "Çatlamış Örs",
  "block.minecraft.chiseled_bookshelf": "Kəsilmiş kitab rəfi",
  "block.minecraft.chiseled_copper": "Yonulmuş mis",
  "block.minecraft.chiseled_deepslate": "Oyulmuş şifer daşı",
  "block.minecraft.chiseled_nether_bricks": "Naxışlı Nezer kərpici",
  "block.minecraft.chiseled_polished_blackstone": "Naxışlı hamar qaradaş",
  "block.minecraft.chiseled_quartz_block": "Oyma Kvars Bloku",
  "block.minecraft.chiseled_red_sandstone": "Oyma Qırmızı Qumdaşı",
  "block.minecraft.chiseled_resin_bricks": "Oyma qatran kərpic bloku",
  "block.minecraft.chiseled_sandstone": "Oyma Qumdaşı",
  "block.minecraft.chiseled_stone_bricks": "Oyma Daş Kərpic",
  "block.minecraft.chiseled_tuff": "Yonulmuş tuf",
  "block.minecraft.chiseled_tuff_bricks": "Yonulmuş tufdan kərpiclər",
  "block.minecraft.chorus_flower": "Nəqarət Çiçəyi",
  "block.minecraft.chorus_plant": "Nəqarət Bitkisi",
  "block.minecraft.clay": "Gil",
  "block.minecraft.closed_eyeblossom": "Qapalı Göz Ağzı",
  "block.minecraft.coal_block": "Kömür Bloku",
  "block.minecraft.coal_ore": "Kömür Filizi",
  "block.minecraft.coarse_dirt": "Cod Torpaq",
  "block.minecraft.cobbled_deepslate": "Qırıq şifer daşı",
  "block.minecraft.cobbled_deepslate_slab": "Daşlamış şifer pillə",
  "block.minecraft.cobbled_deepslate_stairs": "Daşlatmış şifer pilləkan",
  "block.minecraft.cobbled_deepslate_wall": "Daşlaşmiş şifer divar",
  "block.minecraft.cobblestone": "Qırıq Daş",
  "block.minecraft.cobblestone_slab": "Qırıq Daş Pillə",
  "block.minecraft.cobblestone_stairs": "Qırıq Daş Pilləkən",
  "block.minecraft.cobblestone_wall": "Çaydaşı Divar",
  "block.minecraft.cobweb": "Hörümçək Toru",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Əmr Bloku",
  "block.minecraft.comparator": "Qızıl Daş Qarşılaşdırıcı",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Kəmər",
  "block.minecraft.copper_bars": "Mis Çubuqlar",
  "block.minecraft.copper_block": "Mis bloku",
  "block.minecraft.copper_bulb": "Mis Lampa",
  "block.minecraft.copper_chain": "Mis Zəncir",
  "block.minecraft.copper_chest": "Mis Sandıq",
  "block.minecraft.copper_door": "Mis Qapı",
  "block.minecraft.copper_golem_statue": "Mis Qolem Heykəli",
  "block.minecraft.copper_grate": "Mis Barmaqlıq",
  "block.minecraft.copper_lantern": "Mis Fənər",
  "block.minecraft.copper_ore": "Mis filizi",
  "block.minecraft.copper_torch": "Mis Məşəl",
  "block.minecraft.copper_trapdoor": "Mis Tələ Qapısı",
  "block.minecraft.copper_wall_torch": "Divarda mis məşəl",
  "block.minecraft.cornflower": "Güləvər",
  "block.minecraft.cracked_deepslate_bricks": "Qırıq şifer kərpiclər",
  "block.minecraft.cracked_deepslate_tiles": "Qırıq şifer kafeli",
  "block.minecraft.cracked_nether_bricks": "Çatlamış Nezer kərpici",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sınıq hamar qaradaş kərpic",
  "block.minecraft.cracked_stone_bricks": "Çatlaq Daş Kərpic",
  "block.minecraft.crafter": "Hazırlayıcı Masa",
  "block.minecraft.crafting_table": "Hazırlama Masası",
  "block.minecraft.creaking_heart": "Cırıldayan Ürək",
  "block.minecraft.creeper_head": "Creeper Başı",
  "block.minecraft.creeper_wall_head": "Kriper Başı",
  "block.minecraft.crimson_button": "Al düymə",
  "block.minecraft.crimson_door": "Al qapı",
  "block.minecraft.crimson_fence": "Al Çəpər",
  "block.minecraft.crimson_fence_gate": "Al Çəpər Qapısı",
  "block.minecraft.crimson_fungus": "Al göbələk",
  "block.minecraft.crimson_hanging_sign": "Crimson Asma İşarəsi",
  "block.minecraft.crimson_hyphae": "Al hifa",
  "block.minecraft.crimson_nylium": "Al nilium",
  "block.minecraft.crimson_planks": "Al taxta",
  "block.minecraft.crimson_pressure_plate": "Al təzyiq lövhəsi",
  "block.minecraft.crimson_roots": "Al köklər",
  "block.minecraft.crimson_shelf": "Qızılı Rəf",
  "block.minecraft.crimson_sign": "Al lövhə",
  "block.minecraft.crimson_slab": "Al pillə",
  "block.minecraft.crimson_stairs": "Al Pilləkən",
  "block.minecraft.crimson_stem": "Qırmızı saplaq",
  "block.minecraft.crimson_trapdoor": "Al tələ qapısı",
  "block.minecraft.crimson_wall_hanging_sign": "Qırmızı divardan asma nişanı",
  "block.minecraft.crimson_wall_sign": "Qırmızı Divar işarəsi",
  "block.minecraft.crying_obsidian": "Ağlayan obsidian",
  "block.minecraft.cut_copper": "Kəsilmiş mis",
  "block.minecraft.cut_copper_slab": "Kəsilmiş mis pillə",
  "block.minecraft.cut_copper_stairs": "Kəsilmiş Mis Pilləkən",
  "block.minecraft.cut_red_sandstone": "Kəsilmiş qırmızı qum daşı",
  "block.minecraft.cut_red_sandstone_slab": "Kəsilmiş qırmızı qum daşı pillə",
  "block.minecraft.cut_sandstone": "Kəsilmiş qum daşı",
  "block.minecraft.cut_sandstone_slab": "Kəsilmiş qum daşı pillə",
  "block.minecraft.cyan_banner": "Mavi Bayraq",
  "block.minecraft.cyan_bed": "Firuzəyi çarpayı",
  "block.minecraft.cyan_candle": "Firuzəyi şam",
  "block.minecraft.cyan_candle_cake": "Mavi-yaşıl şam ilə tort",
  "block.minecraft.cyan_carpet": "Mavi Xalça",
  "block.minecraft.cyan_concrete": "Mavi Beton",
  "block.minecraft.cyan_concrete_powder": "Mavi Sement",
  "block.minecraft.cyan_glazed_terracotta": "Firuzəyi şirli terrakotta",
  "block.minecraft.cyan_shulker_box": "Mavi Shulker Qutusu",
  "block.minecraft.cyan_stained_glass": "Mavi Rəngli Şüşə",
  "block.minecraft.cyan_stained_glass_pane": "Mavi Rəngli İncə Şüşə",
  "block.minecraft.cyan_terracotta": "Firuzəyi terrakotta",
  "block.minecraft.cyan_wool": "Mavi Yun",
  "block.minecraft.damaged_anvil": "Sınmış Örs",
  "block.minecraft.dandelion": "Zəncirotu",
  "block.minecraft.dark_oak_button": "Qara Palıd Düymə",
  "block.minecraft.dark_oak_door": "Qara Palıd Qapı",
  "block.minecraft.dark_oak_fence": "Qara Palıd Çəpər",
  "block.minecraft.dark_oak_fence_gate": "Qara Palıd Çəpər Qapısı",
  "block.minecraft.dark_oak_hanging_sign": "Tünd palıd asma lövhəsi",
  "block.minecraft.dark_oak_leaves": "Qara Palıd Yarpaqları",
  "block.minecraft.dark_oak_log": "Qara Palıd Kötüyü",
  "block.minecraft.dark_oak_planks": "Qara Palıd Taxta",
  "block.minecraft.dark_oak_pressure_plate": "Qara Palıd Təyziq Təbəqəsi",
  "block.minecraft.dark_oak_sapling": "Qara Palıd Fidanı",
  "block.minecraft.dark_oak_shelf": "Tünd Meşə Rəf",
  "block.minecraft.dark_oak_sign": "Qara Palıd Lövhə",
  "block.minecraft.dark_oak_slab": "Qara Palıd Pillə",
  "block.minecraft.dark_oak_stairs": "Qara Palıd Pilləkən",
  "block.minecraft.dark_oak_trapdoor": "Qara Palıd Tələ Qapısı",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tünd palıd divardan asma nişanı",
  "block.minecraft.dark_oak_wall_sign": "Divarda Qara Palıd Lövhə",
  "block.minecraft.dark_oak_wood": "Qara Palıd Odunu",
  "block.minecraft.dark_prismarine": "Qara Prizmarin",
  "block.minecraft.dark_prismarine_slab": "Qara prizmarin pillə",
  "block.minecraft.dark_prismarine_stairs": "Qara prizmarin pilləkən",
  "block.minecraft.daylight_detector": "Gün İşığı Dedektoru",
  "block.minecraft.dead_brain_coral": "Ölü Beyin Mərcan",
  "block.minecraft.dead_brain_coral_block": "Ölü beyin mərcan bloku",
  "block.minecraft.dead_brain_coral_fan": "Ölü beyin mərcan fanatı",
  "block.minecraft.dead_brain_coral_wall_fan": "Ölü beyin mərcan divar fanatı\n",
  "block.minecraft.dead_bubble_coral": "Ölü Baloncuk Mərcan",
  "block.minecraft.dead_bubble_coral_block": "Ölü baloncuk mərcan bloku",
  "block.minecraft.dead_bubble_coral_fan": "Ölü beyin mərcan fanatı\n",
  "block.minecraft.dead_bubble_coral_wall_fan": "Ölü köpük mərcan divar fanatı",
  "block.minecraft.dead_bush": "Ölü Bitki",
  "block.minecraft.dead_fire_coral": "Ölü Atəş Mərcan",
  "block.minecraft.dead_fire_coral_block": "Ölü atəş mərcan bloku",
  "block.minecraft.dead_fire_coral_fan": "Ölü yandırmiş mərcan",
  "block.minecraft.dead_fire_coral_wall_fan": "Ölü yanğın mərcan divar fanatı",
  "block.minecraft.dead_horn_coral": "Ölü Buynuz Mərcan",
  "block.minecraft.dead_horn_coral_block": "Ölü buynuz mərcan bloku",
  "block.minecraft.dead_horn_coral_fan": "Ölü buynuzlu mərcan ",
  "block.minecraft.dead_horn_coral_wall_fan": "Ölü buynuz mərcan divar fanatı",
  "block.minecraft.dead_tube_coral": "Ölü Boru Mərcan",
  "block.minecraft.dead_tube_coral_block": "Ölü boru mərcan bloku",
  "block.minecraft.dead_tube_coral_fan": "Ölü boru mərcan",
  "block.minecraft.dead_tube_coral_wall_fan": "Ölü Mərcan Bitkisi",
  "block.minecraft.decorated_pot": "Bəzəkli Qazan",
  "block.minecraft.deepslate": "Şifer daşı",
  "block.minecraft.deepslate_brick_slab": "Şifer daşı kərpicindən pillə",
  "block.minecraft.deepslate_brick_stairs": "Şifer daşı kərpicindən pilləkən",
  "block.minecraft.deepslate_brick_wall": "Şifer daşı kərpicindən divar",
  "block.minecraft.deepslate_bricks": "Şifer daşı kərpicləri",
  "block.minecraft.deepslate_coal_ore": "Şiferli kömür filizi",
  "block.minecraft.deepslate_copper_ore": "Şiferli mis filizi",
  "block.minecraft.deepslate_diamond_ore": "Şiferli almaz filizi",
  "block.minecraft.deepslate_emerald_ore": "Şiferli zümrüd filizi",
  "block.minecraft.deepslate_gold_ore": "Şiferli qızıl filizi",
  "block.minecraft.deepslate_iron_ore": "Şiferli dəmir filizi",
  "block.minecraft.deepslate_lapis_ore": "Şiferli Lacivərd Filizi",
  "block.minecraft.deepslate_redstone_ore": "Şiferli qırmızıdaş filizi",
  "block.minecraft.deepslate_tile_slab": "Şifer daşı kafelindən pillə",
  "block.minecraft.deepslate_tile_stairs": "Şifer daşı kafelindən pilləkən",
  "block.minecraft.deepslate_tile_wall": "Şifer daşı kafelindən divar",
  "block.minecraft.deepslate_tiles": "Şifer daşı kafeli",
  "block.minecraft.detector_rail": "Dedektor Rels",
  "block.minecraft.diamond_block": "Almaz Bloku",
  "block.minecraft.diamond_ore": "Almaz Filizi",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Diorit Pillə",
  "block.minecraft.diorite_stairs": "Diorit Pilləkan",
  "block.minecraft.diorite_wall": "Diorit Divar",
  "block.minecraft.dirt": "Torpaq",
  "block.minecraft.dirt_path": "Torpaq Yol",
  "block.minecraft.dispenser": "Atıcı",
  "block.minecraft.dragon_egg": "Əjdaha Yumurtası",
  "block.minecraft.dragon_head": "Əjdaha Başı",
  "block.minecraft.dragon_wall_head": "Əjdaha başı",
  "block.minecraft.dried_ghast": "Qurudulmuş Ghast",
  "block.minecraft.dried_kelp_block": "Qurudulmuş Yosun Bloku",
  "block.minecraft.dripstone_block": "Damcı daşı bloku",
  "block.minecraft.dropper": "Buraxıcı",
  "block.minecraft.emerald_block": "Zümrüd Bloku",
  "block.minecraft.emerald_ore": "Zümrüd Filizi",
  "block.minecraft.enchanting_table": "Sehrbazlıq Masası",
  "block.minecraft.end_gateway": "End keçidi",
  "block.minecraft.end_portal": "End Keçidi",
  "block.minecraft.end_portal_frame": "End portalı strukturu",
  "block.minecraft.end_rod": "End Çubuğu",
  "block.minecraft.end_stone": "End Daşı",
  "block.minecraft.end_stone_brick_slab": "End daşı kərpici pilləsi",
  "block.minecraft.end_stone_brick_stairs": "End Daşı Kərpici Pilləkən",
  "block.minecraft.end_stone_brick_wall": "End daşı kərpici divarı",
  "block.minecraft.end_stone_bricks": "End Daşı Kərpic",
  "block.minecraft.ender_chest": "Ender Sandıqı",
  "block.minecraft.exposed_chiseled_copper": "Açıq kəsilmiş mis",
  "block.minecraft.exposed_copper": "Müdafiəsiz qalmış mis",
  "block.minecraft.exposed_copper_bars": "Açıqda Qalmış Mis Barlar",
  "block.minecraft.exposed_copper_bulb": "Açıq Mis Lampa",
  "block.minecraft.exposed_copper_chain": "Açıqda Qalmış Mis Zəncir",
  "block.minecraft.exposed_copper_chest": "Açıqda Qalmış Mis Sandıq",
  "block.minecraft.exposed_copper_door": "Açıq Mis Qapı",
  "block.minecraft.exposed_copper_golem_statue": "Açıqda Qalmış Mis Qolem Heykəli",
  "block.minecraft.exposed_copper_grate": "Açıq Mis Barmaqlıq",
  "block.minecraft.exposed_copper_lantern": "Açıqda Qalmış Mis Fənər",
  "block.minecraft.exposed_copper_trapdoor": "Mumlu Açıq Mis Qapı",
  "block.minecraft.exposed_cut_copper": "Müdafiəsiz qalmış kəsilmiş mis",
  "block.minecraft.exposed_cut_copper_slab": "Müdafiəsiz qalmış kəsilmiş mis pillə",
  "block.minecraft.exposed_cut_copper_stairs": "Müdafiəsiz Qalmış Kəsilmiş Mis Pilləkən",
  "block.minecraft.exposed_lightning_rod": "Açıqda Qalmış İldırım Ötürücü",
  "block.minecraft.farmland": "Tarla Ərazısı",
  "block.minecraft.fern": "Qıjı",
  "block.minecraft.fire": "Atəş",
  "block.minecraft.fire_coral": "Atəş mərcan",
  "block.minecraft.fire_coral_block": "Atəş Mərcan Bloku",
  "block.minecraft.fire_coral_fan": "Yanğın Mərcan fanatı",
  "block.minecraft.fire_coral_wall_fan": "Yandırmış boru mərcan divarı",
  "block.minecraft.firefly_bush": "İşıldaquş Kolu",
  "block.minecraft.fletching_table": "Oxçu masası",
  "block.minecraft.flower_pot": "Saxsı",
  "block.minecraft.flowering_azalea": "Çiçəkləyən azaliya",
  "block.minecraft.flowering_azalea_leaves": "Çiçəkləyən azaliya yarpaqları",
  "block.minecraft.frogspawn": "Qurbağa Yumurtaları",
  "block.minecraft.frosted_ice": "Şaxta",
  "block.minecraft.furnace": "Soba",
  "block.minecraft.gilded_blackstone": "Zərli qaradaş",
  "block.minecraft.glass": "Şüşə",
  "block.minecraft.glass_pane": "İncə Şüşə",
  "block.minecraft.glow_lichen": "Parıldayan şibyə",
  "block.minecraft.glowstone": "İşıq Daşı",
  "block.minecraft.gold_block": "Qızıl Bloku",
  "block.minecraft.gold_ore": "Qızıl Filizi",
  "block.minecraft.golden_dandelion": "Qızıl zəncirotu",
  "block.minecraft.granite": "Qranit",
  "block.minecraft.granite_slab": "Qranit pillə",
  "block.minecraft.granite_stairs": "Qranit Pilləkən",
  "block.minecraft.granite_wall": "Qranit Divar",
  "block.minecraft.grass": "Ot",
  "block.minecraft.grass_block": "Otlu Torpaq",
  "block.minecraft.gravel": "Çınqıl",
  "block.minecraft.gray_banner": "Boz Bayraq",
  "block.minecraft.gray_bed": "Boz Çarpayı",
  "block.minecraft.gray_candle": "Boz Şam",
  "block.minecraft.gray_candle_cake": "Boz şam ilə tort",
  "block.minecraft.gray_carpet": "Boz Xalça",
  "block.minecraft.gray_concrete": "Boz Beton",
  "block.minecraft.gray_concrete_powder": "Boz Sement",
  "block.minecraft.gray_glazed_terracotta": "Boz Şirli Terrakotta",
  "block.minecraft.gray_shulker_box": "Boz Shulker Qutusu",
  "block.minecraft.gray_stained_glass": "Boz Rəngli Şüşə",
  "block.minecraft.gray_stained_glass_pane": "Boz Rəngli İncə Şüşə",
  "block.minecraft.gray_terracotta": "Boz terrakotta",
  "block.minecraft.gray_wool": "Boz Yun",
  "block.minecraft.green_banner": "Yaşıl Bayraq",
  "block.minecraft.green_bed": "Yaşıl çarpayı",
  "block.minecraft.green_candle": "Yaşıl Şam",
  "block.minecraft.green_candle_cake": "Yaşıl şamlı tort",
  "block.minecraft.green_carpet": "Yaşıl Xalça",
  "block.minecraft.green_concrete": "Yaşıl Beton",
  "block.minecraft.green_concrete_powder": "Yaşıl Sement",
  "block.minecraft.green_glazed_terracotta": "Yaşıl Şirli Terrakotta",
  "block.minecraft.green_shulker_box": "Yaşıl Shulker Qutusu",
  "block.minecraft.green_stained_glass": "Yaşıl Rəngli Şüşə",
  "block.minecraft.green_stained_glass_pane": "Yaşıl Rəngli İncə Şüşə",
  "block.minecraft.green_terracotta": "Yaşıl terrakotta",
  "block.minecraft.green_wool": "Yaşıl Yun",
  "block.minecraft.grindstone": "İtiləmə",
  "block.minecraft.hanging_roots": "Sallanan köklər",
  "block.minecraft.hay_block": "Saman tayası",
  "block.minecraft.heavy_core": "Ağır nüvə",
  "block.minecraft.heavy_weighted_pressure_plate": "Sərt Ağırlıqlı Təyziq Təbəqəsi",
  "block.minecraft.honey_block": "Bal Bloku",
  "block.minecraft.honeycomb_block": "Bal Pətəyi Bloku",
  "block.minecraft.hopper": "Süzgəc",
  "block.minecraft.horn_coral": "Buynuz mərcan",
  "block.minecraft.horn_coral_block": "Buynuz mərcan bloku",
  "block.minecraft.horn_coral_fan": "Buynuz mərcan fanat",
  "block.minecraft.horn_coral_wall_fan": "Buynuz Mərcan Divar fanatı",
  "block.minecraft.ice": "Buz",
  "block.minecraft.infested_chiseled_stone_bricks": "Yoluxmuş Oyma Daş Kərpic",
  "block.minecraft.infested_cobblestone": "Daraşılmış Çaydaşı",
  "block.minecraft.infested_cracked_stone_bricks": "Yoluxmuş Çatlamış Daş Kərpic",
  "block.minecraft.infested_deepslate": "Daraşılmış Şifer Daşı",
  "block.minecraft.infested_mossy_stone_bricks": "Daraşılmış Mamırlı Daş Kərpic",
  "block.minecraft.infested_stone": "Daraşılmış Daş",
  "block.minecraft.infested_stone_bricks": "Daraşılmış Daş Kərpic",
  "block.minecraft.iron_bars": "Dəmir Barmaqlıq",
  "block.minecraft.iron_block": "Dəmir Bloku",
  "block.minecraft.iron_chain": "Dəmir Zəncir",
  "block.minecraft.iron_door": "Dəmir Qapı",
  "block.minecraft.iron_ore": "Dəmir Filizi",
  "block.minecraft.iron_trapdoor": "Dəmir Tələ Qapısı",
  "block.minecraft.jack_o_lantern": "Balqabaq Lampası",
  "block.minecraft.jigsaw": "Pazl Bloku",
  "block.minecraft.jukebox": "Musiqi Qutusu",
  "block.minecraft.jungle_button": "Cəngəllik Ağacı Düymə",
  "block.minecraft.jungle_door": "Cəngəllik Ağacı Qapı",
  "block.minecraft.jungle_fence": "Cəngəllik Ağacı Çəpər",
  "block.minecraft.jungle_fence_gate": "Cəngəllik Ağacı Çəpər Qapısı",
  "block.minecraft.jungle_hanging_sign": "Jungle Asma İşarəsi",
  "block.minecraft.jungle_leaves": "Cəngəllik Ağacı Yarpaqları",
  "block.minecraft.jungle_log": "Cəngəllik kötüyü",
  "block.minecraft.jungle_planks": "Cəngəllik Ağacı Taxta",
  "block.minecraft.jungle_pressure_plate": "Cəngəllik Ağacı Təyziq Təbəqəsi",
  "block.minecraft.jungle_sapling": "Cəngəllik Ağacı Fidanı",
  "block.minecraft.jungle_shelf": "Cəngəllik Rəf",
  "block.minecraft.jungle_sign": "Cəngəllik Ağacı Lövhə",
  "block.minecraft.jungle_slab": "Cəngəllik Ağacı Pillə",
  "block.minecraft.jungle_stairs": "Cəngəllik Ağacı Pilləkən",
  "block.minecraft.jungle_trapdoor": "Cəngəllik Ağacı Tələ Qapısı",
  "block.minecraft.jungle_wall_hanging_sign": "Cəngəllik Divarında Asma Nişanı",
  "block.minecraft.jungle_wall_sign": "Divarda Cəngəllik Ağacı Lövhə",
  "block.minecraft.jungle_wood": "Cəngəllik Ağacı Odunu",
  "block.minecraft.kelp": "Yosun",
  "block.minecraft.kelp_plant": "Kelp bitkisi",
  "block.minecraft.ladder": "Nərdivan",
  "block.minecraft.lantern": "Fənər",
  "block.minecraft.lapis_block": "Lacivərd Bloku",
  "block.minecraft.lapis_ore": "Lapis Lazuli Filizi",
  "block.minecraft.large_amethyst_bud": "Böyük ametist tumurcuğu",
  "block.minecraft.large_fern": "İri Qıjı",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lava qazanı",
  "block.minecraft.leaf_litter": "Xəzəl",
  "block.minecraft.lectern": "Kafedra",
  "block.minecraft.lever": "Ling",
  "block.minecraft.light": "İşıq",
  "block.minecraft.light_blue_banner": "Açıq Göy Bayraq",
  "block.minecraft.light_blue_bed": "Açıq göy çarpayı",
  "block.minecraft.light_blue_candle": "Açıq Göy Şam",
  "block.minecraft.light_blue_candle_cake": "Açıq mavi şam ilə tort",
  "block.minecraft.light_blue_carpet": "Açıq Göy Xalça",
  "block.minecraft.light_blue_concrete": "Açıq Göy Beton",
  "block.minecraft.light_blue_concrete_powder": "Açıq Göy Sement",
  "block.minecraft.light_blue_glazed_terracotta": "Açıq göy şirli terrakotta",
  "block.minecraft.light_blue_shulker_box": "Açıq Göy Shulker Qutusu",
  "block.minecraft.light_blue_stained_glass": "Açıq Göy Rəngli Şüşə",
  "block.minecraft.light_blue_stained_glass_pane": "Açıq Göy Rəngli İncə Şüşə",
  "block.minecraft.light_blue_terracotta": "Açıq göy terrakotta",
  "block.minecraft.light_blue_wool": "Açıq Göy Yun",
  "block.minecraft.light_gray_banner": "Açıq Boz Bayraq",
  "block.minecraft.light_gray_bed": "Açıq Boz Çarpayı",
  "block.minecraft.light_gray_candle": "Açıq boz şam",
  "block.minecraft.light_gray_candle_cake": "Açıq boz şam ilə tort",
  "block.minecraft.light_gray_carpet": "Açıq Boz Xalça",
  "block.minecraft.light_gray_concrete": "Açıq Boz Beton",
  "block.minecraft.light_gray_concrete_powder": "Açıq Boz Sement",
  "block.minecraft.light_gray_glazed_terracotta": "Açıq boz çirli terrakotta",
  "block.minecraft.light_gray_shulker_box": "Açıq Boz Shulker Qutusu",
  "block.minecraft.light_gray_stained_glass": "Açıq Boz Rəngli Şüşə",
  "block.minecraft.light_gray_stained_glass_pane": "Açıq Boz Rəngli İncə Şüşə",
  "block.minecraft.light_gray_terracotta": "Açıq Boz Terrakotta",
  "block.minecraft.light_gray_wool": "Açıq Boz Yun",
  "block.minecraft.light_weighted_pressure_plate": "Həssas Ağırlıqlı Təyziq Təbəqəsi",
  "block.minecraft.lightning_rod": "İldırım ötürücü",
  "block.minecraft.lilac": "Yasəmən",
  "block.minecraft.lily_of_the_valley": "May inciçiçəyi",
  "block.minecraft.lily_pad": "Suzanbağı",
  "block.minecraft.lime_banner": "Açıq Yaşıl Bayraq",
  "block.minecraft.lime_bed": "Açıq Yaşıl Çarpayı",
  "block.minecraft.lime_candle": "Açıq yaşıl şam",
  "block.minecraft.lime_candle_cake": "Əhəng şam ilə tort",
  "block.minecraft.lime_carpet": "Açıq Yaşıl Xalça",
  "block.minecraft.lime_concrete": "Açıq Yaşıl Beton",
  "block.minecraft.lime_concrete_powder": "Açıq Yaşıl Sement",
  "block.minecraft.lime_glazed_terracotta": "Laym Şirli Terrakotta",
  "block.minecraft.lime_shulker_box": "Açıq Yaşıl Shulker Qutusu",
  "block.minecraft.lime_stained_glass": "Açıq Yaşıl Rəngli Şüşə",
  "block.minecraft.lime_stained_glass_pane": "Açıq Yaşıl Rəngli İncə Şüşə",
  "block.minecraft.lime_terracotta": "Açıq yaşıl terrakotta",
  "block.minecraft.lime_wool": "Açıq Yaşıl Yun",
  "block.minecraft.lodestone": "Maqnitləşmis daş",
  "block.minecraft.loom": "Toxucu dəzgahı",
  "block.minecraft.magenta_banner": "Magenta Bayraq",
  "block.minecraft.magenta_bed": "Macenta çarpayı",
  "block.minecraft.magenta_candle": "Macenta şam",
  "block.minecraft.magenta_candle_cake": "Bənövşəyi-qırmızı şam ilə tort",
  "block.minecraft.magenta_carpet": "Magenta Rəngli Xalça",
  "block.minecraft.magenta_concrete": "Magenta Beton",
  "block.minecraft.magenta_concrete_powder": "Magenta Sement",
  "block.minecraft.magenta_glazed_terracotta": "Magenta Şirli Terrakotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker Qutusu",
  "block.minecraft.magenta_stained_glass": "Magenta Rəngli Şüşə",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Rəngli İncə Şüşə",
  "block.minecraft.magenta_terracotta": "Macenta terrakotta",
  "block.minecraft.magenta_wool": "Magenta Yun",
  "block.minecraft.magma_block": "Magma Bloku",
  "block.minecraft.mangrove_button": "Manqrov Düymə",
  "block.minecraft.mangrove_door": "Manqrov Qapı",
  "block.minecraft.mangrove_fence": "Manqrov Çəpər",
  "block.minecraft.mangrove_fence_gate": "Manqrov Çəpər Qapısı",
  "block.minecraft.mangrove_hanging_sign": "Mangrov Asma İşarəsi",
  "block.minecraft.mangrove_leaves": "Manqrov Yarpaqları",
  "block.minecraft.mangrove_log": "Manqrov Kötüyü",
  "block.minecraft.mangrove_planks": "Manqrov Taxta",
  "block.minecraft.mangrove_pressure_plate": "Manqrov Təyziq Təbəqəsi",
  "block.minecraft.mangrove_propagule": "Manqrov Fidanı",
  "block.minecraft.mangrove_roots": "Manqrov Kökləri",
  "block.minecraft.mangrove_shelf": "Manqrov Rəf",
  "block.minecraft.mangrove_sign": "Manqrov Lövhə",
  "block.minecraft.mangrove_slab": "Manqrov Pillə",
  "block.minecraft.mangrove_stairs": "Manqrov Pilləkən",
  "block.minecraft.mangrove_trapdoor": "Manqrov Tələ Qapısı",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrov Divar Asma İşarəsi",
  "block.minecraft.mangrove_wall_sign": "Divarda Manqrov Lövhə",
  "block.minecraft.mangrove_wood": "Manqrov Odunu",
  "block.minecraft.medium_amethyst_bud": "Orta ametist tumurcuğu",
  "block.minecraft.melon": "Qarpız",
  "block.minecraft.melon_stem": "Qarpız sapı",
  "block.minecraft.moss_block": "Mamır bloku",
  "block.minecraft.moss_carpet": "Mamır xalçası",
  "block.minecraft.mossy_cobblestone": "Mamırlı Çaydaşı",
  "block.minecraft.mossy_cobblestone_slab": "Mamırlı Çaydaşı Pillə",
  "block.minecraft.mossy_cobblestone_stairs": "Mamırlı Çaydaşı Pilləkən",
  "block.minecraft.mossy_cobblestone_wall": "Mamırlı Qırıq Daş Divarı",
  "block.minecraft.mossy_stone_brick_slab": "Mamırlı Daş Kərpic Pillə",
  "block.minecraft.mossy_stone_brick_stairs": "Mamırlı Daş Kərpic Pilləkən",
  "block.minecraft.mossy_stone_brick_wall": "Mamırlı Daş Kərpic Divar",
  "block.minecraft.mossy_stone_bricks": "Mamırlı Daş Kərpic",
  "block.minecraft.moving_piston": "Hərəkətli Piston",
  "block.minecraft.mud": "Palçıq",
  "block.minecraft.mud_brick_slab": "Palçıq kərpic pillə",
  "block.minecraft.mud_brick_stairs": "Palçıq kərpic pilləkən",
  "block.minecraft.mud_brick_wall": "Palçıq kərpic divar",
  "block.minecraft.mud_bricks": "Palçıq Kərpici",
  "block.minecraft.muddy_mangrove_roots": "Palçıqlı Manqrov Kökləri",
  "block.minecraft.mushroom_stem": "Göbələk Sapı",
  "block.minecraft.mycelium": "Mitseli",
  "block.minecraft.nether_brick_fence": "Nether Kərpici Çəpər",
  "block.minecraft.nether_brick_slab": "Nether Kərpici Pillə",
  "block.minecraft.nether_brick_stairs": "Nether Kərpici Pilləkən",
  "block.minecraft.nether_brick_wall": "Nezer kərpici divarı",
  "block.minecraft.nether_bricks": "Nether Kərpici",
  "block.minecraft.nether_gold_ore": "Cəhənnəm qızıl filizi",
  "block.minecraft.nether_portal": "Nezer portalı",
  "block.minecraft.nether_quartz_ore": "Nether Kvarsı Filizi",
  "block.minecraft.nether_sprouts": "Nezer soğu",
  "block.minecraft.nether_wart": "Nether göbələyi",
  "block.minecraft.nether_wart_block": "Nezer ziyili bloku",
  "block.minecraft.netherite_block": "Nezerit bloku",
  "block.minecraft.netherrack": "Nether Daşı",
  "block.minecraft.note_block": "Not Bloku",
  "block.minecraft.oak_button": "Palıd Düymə",
  "block.minecraft.oak_door": "Palıd Qapı",
  "block.minecraft.oak_fence": "Palıd Çəpər",
  "block.minecraft.oak_fence_gate": "Palıd Çəpər Qapısı",
  "block.minecraft.oak_hanging_sign": "Palıd Asma İşarəsi",
  "block.minecraft.oak_leaves": "Palıd Yarpaqları",
  "block.minecraft.oak_log": "Palıd kötüyü",
  "block.minecraft.oak_planks": "Palıd Taxta",
  "block.minecraft.oak_pressure_plate": "Palıd Təyziq Təbəqəsi",
  "block.minecraft.oak_sapling": "Palıd Fidanı",
  "block.minecraft.oak_shelf": "Meşə Rəf",
  "block.minecraft.oak_sign": "Palıd Lövhə",
  "block.minecraft.oak_slab": "Palıd Pillə",
  "block.minecraft.oak_stairs": "Palıd Pilləkən",
  "block.minecraft.oak_trapdoor": "Palıd Tələ Qapısı",
  "block.minecraft.oak_wall_hanging_sign": "Palıd Divardan Asma Nişanı",
  "block.minecraft.oak_wall_sign": "Divarda Palıd Lövhə",
  "block.minecraft.oak_wood": "Palıd odunu",
  "block.minecraft.observer": "Gözləmçi",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Oxra qurbağaişıq",
  "block.minecraft.ominous_banner": "Uğursuz bayraq",
  "block.minecraft.open_eyeblossom": "Açıq gözçiçəyi",
  "block.minecraft.orange_banner": "Narıncı Bayraq",
  "block.minecraft.orange_bed": "Narıncı çarpayı",
  "block.minecraft.orange_candle": "Narıncı Şam",
  "block.minecraft.orange_candle_cake": "Narıncı şamlı tort",
  "block.minecraft.orange_carpet": "Narıncı Xalça",
  "block.minecraft.orange_concrete": "Narıncı Beton",
  "block.minecraft.orange_concrete_powder": "Narıncı Sement",
  "block.minecraft.orange_glazed_terracotta": "Narıncı şirli terrakotta",
  "block.minecraft.orange_shulker_box": "Narıncı Shulker Qutusu",
  "block.minecraft.orange_stained_glass": "Narıncı Rəngli Şüşə",
  "block.minecraft.orange_stained_glass_pane": "Narıncı Rəngli İncə Şüşə",
  "block.minecraft.orange_terracotta": "Narıncı terrakotta",
  "block.minecraft.orange_tulip": "Narıncı Lalə",
  "block.minecraft.orange_wool": "Narıncı Yun",
  "block.minecraft.oxeye_daisy": "Çobanyastığı",
  "block.minecraft.oxidized_chiseled_copper": "Oksidləşdirilmiş kəsilmiş mis",
  "block.minecraft.oxidized_copper": "Oksidləşmiş mis",
  "block.minecraft.oxidized_copper_bars": "Oksidləşdirilmiş Mis Barlar",
  "block.minecraft.oxidized_copper_bulb": "Oksidləşdirilmiş mis lampa",
  "block.minecraft.oxidized_copper_chain": "Oksidləşdirilmiş Mis Zəncir",
  "block.minecraft.oxidized_copper_chest": "Oksidləşdirilmiş Mis Sandıq",
  "block.minecraft.oxidized_copper_door": "Oksidləşdirilmiş Mis Qapı",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidləşdirilmiş Mis Qolem Heykəli",
  "block.minecraft.oxidized_copper_grate": "Oksidləşdirilmiş Mis ızgara",
  "block.minecraft.oxidized_copper_lantern": "Oksidləşdirilmiş Mis Fənər",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidləşmiş Mis Qapı",
  "block.minecraft.oxidized_cut_copper": "Oksidləşmiş kəsilmiş mis",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidləşmiş kəsilmiş mis pillə",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidləşmiş Kəsilmiş Mis Pilləkən",
  "block.minecraft.oxidized_lightning_rod": "Oksidləşdirilmiş İldırım Ötürücü",
  "block.minecraft.packed_ice": "Paketlənmiş Buz",
  "block.minecraft.packed_mud": "Bükülmüş palçıq",
  "block.minecraft.pale_hanging_moss": "Sallanan solğun mamır",
  "block.minecraft.pale_moss_block": "Solğun mamır bloku",
  "block.minecraft.pale_moss_carpet": "Solğun mamır xalçası",
  "block.minecraft.pale_oak_button": "Solğun palıd düyməsi",
  "block.minecraft.pale_oak_door": "Solğun palıd qapısı",
  "block.minecraft.pale_oak_fence": "Ağ Palıd Çəpər",
  "block.minecraft.pale_oak_fence_gate": "Ağ Palıd Çəpər Qapısı",
  "block.minecraft.pale_oak_hanging_sign": "Ağ Palıd Asma Lövhəsi",
  "block.minecraft.pale_oak_leaves": "Ağ Palıd Yarpaqları",
  "block.minecraft.pale_oak_log": "Ağ Palıd Odunu",
  "block.minecraft.pale_oak_planks": "Ağ Palıd Taxtası",
  "block.minecraft.pale_oak_pressure_plate": "Solğun Palıd Basqı Plitəsi",
  "block.minecraft.pale_oak_sapling": "Ağ Palıd Şitili",
  "block.minecraft.pale_oak_shelf": "Solğun Meşə Rəf",
  "block.minecraft.pale_oak_sign": "Ağ Palıd Lövhəsi",
  "block.minecraft.pale_oak_slab": "Ağ Palıd YarımTaxtası",
  "block.minecraft.pale_oak_stairs": "Ağ Palıd Pilləsi",
  "block.minecraft.pale_oak_trapdoor": "Ağ Palıd Tələ Qapısı",
  "block.minecraft.pale_oak_wall_hanging_sign": "Ağ Palıd Divardan Asma Lövhəsi",
  "block.minecraft.pale_oak_wall_sign": "Ağ Palıd Divar Lövhəsi",
  "block.minecraft.pale_oak_wood": "Ağ Palıd Kötüyü",
  "block.minecraft.pearlescent_froglight": "Sədəfli qurbağaişıq",
  "block.minecraft.peony": "Pion",
  "block.minecraft.petrified_oak_slab": "Daşlaşmış Palıd Pillə",
  "block.minecraft.piglin_head": "Piglin rəhbəri",
  "block.minecraft.piglin_wall_head": "Piglin Divar Başı",
  "block.minecraft.pink_banner": "Çəhrayı Bayraq",
  "block.minecraft.pink_bed": "Çəhrayı Çarpayı",
  "block.minecraft.pink_candle": "Çəhrayı Şam",
  "block.minecraft.pink_candle_cake": "Çəhrayı şam ilə tort",
  "block.minecraft.pink_carpet": "Çəhrayı Xalça",
  "block.minecraft.pink_concrete": "Çəhrayı Beton",
  "block.minecraft.pink_concrete_powder": "Çəhrayı Sement",
  "block.minecraft.pink_glazed_terracotta": "Çəhrayı Şirli Terrakotta",
  "block.minecraft.pink_petals": "Çəhrayı ləçəklər",
  "block.minecraft.pink_shulker_box": "Çəhrayı Shulker Qutusu",
  "block.minecraft.pink_stained_glass": "Çəyrayı Rəngli Şüşə",
  "block.minecraft.pink_stained_glass_pane": "Çəyrayı Rəngli İncə Şüşə",
  "block.minecraft.pink_terracotta": "Çəhrayı terrakotta",
  "block.minecraft.pink_tulip": "Çəhrayı Lalə",
  "block.minecraft.pink_wool": "Çəhrayı Yun",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Piston başlığı",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Sürahi Zavodu",
  "block.minecraft.player_head": "Oyunçu Başı",
  "block.minecraft.player_head.named": "%s'in Başı",
  "block.minecraft.player_wall_head": "Oyuncu Başı",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "İtiuclu damcı daşı bloku",
  "block.minecraft.polished_andesite": "Cilalanmış Andezit",
  "block.minecraft.polished_andesite_slab": "Cilalanmış Andezit Pillə",
  "block.minecraft.polished_andesite_stairs": "Cilalanmış Andezit Pilləkan",
  "block.minecraft.polished_basalt": "Hamar bazalt",
  "block.minecraft.polished_blackstone": "Hamar qaradaş",
  "block.minecraft.polished_blackstone_brick_slab": "Hamar qaradaş kərpic pilləsi",
  "block.minecraft.polished_blackstone_brick_stairs": "Cilalı Qaradaş Kərpic Pilləkən",
  "block.minecraft.polished_blackstone_brick_wall": "Hamar qaradaş kərpic divar",
  "block.minecraft.polished_blackstone_bricks": "Hamar qaradaş kərpic",
  "block.minecraft.polished_blackstone_button": "Hamar qaradaş düymə",
  "block.minecraft.polished_blackstone_pressure_plate": "Hamar qaradaş təzyiq lövhəsi",
  "block.minecraft.polished_blackstone_slab": "Hamar qaradaş pillə",
  "block.minecraft.polished_blackstone_stairs": "Cilalı Qaradaş Pilləkən",
  "block.minecraft.polished_blackstone_wall": "Hamar qaradaş divar",
  "block.minecraft.polished_deepslate": "Hamar şifer daşı",
  "block.minecraft.polished_deepslate_slab": "Hamar şifer daşı pillə",
  "block.minecraft.polished_deepslate_stairs": "Hamar şifer daşı pilləkən",
  "block.minecraft.polished_deepslate_wall": "Hamar şifer daşı divar",
  "block.minecraft.polished_diorite": "Cilalanmış Diorit",
  "block.minecraft.polished_diorite_slab": "Cilalanmış Diorit Pillə",
  "block.minecraft.polished_diorite_stairs": "Cilalanmış Diorit Pilləkən",
  "block.minecraft.polished_granite": "Cilalanmış Qranit",
  "block.minecraft.polished_granite_slab": "Cilalanmış Qranit Pillə",
  "block.minecraft.polished_granite_stairs": "Cilalanmış Qranit Pilləkən",
  "block.minecraft.polished_tuff": "Cilalanmış tuf",
  "block.minecraft.polished_tuff_slab": "Cilalanmış tuf pilləsi",
  "block.minecraft.polished_tuff_stairs": "Cilalanmış Tüf Pilləkənləri",
  "block.minecraft.polished_tuff_wall": "Cilalanmış Tuf Divarı",
  "block.minecraft.poppy": "Xaşxaş",
  "block.minecraft.potatoes": "Kartoflar",
  "block.minecraft.potted_acacia_sapling": "Akasiya Fidanı Saxsısı",
  "block.minecraft.potted_allium": "Dibçəkli soğan",
  "block.minecraft.potted_azalea_bush": "Dibçəkli azaliya",
  "block.minecraft.potted_azure_bluet": "Hüstoniya Saxsısı",
  "block.minecraft.potted_bamboo": "Dibçəkli Bambuk",
  "block.minecraft.potted_birch_sapling": "Dibçəkli Ağcaqayın Fidanı",
  "block.minecraft.potted_blue_orchid": "Dibçəkli göy səhləb",
  "block.minecraft.potted_brown_mushroom": "Qəhvəyi Göbələk Saxsısı",
  "block.minecraft.potted_cactus": "Dibçəkli Kaktus",
  "block.minecraft.potted_cherry_sapling": "Saxsı Albalı Fidanı",
  "block.minecraft.potted_closed_eyeblossom": "Qazanmış göz qapağı çiçək",
  "block.minecraft.potted_cornflower": "Dibçəkli Göy Reyhan",
  "block.minecraft.potted_crimson_fungus": "Dibçəkli al göbələk",
  "block.minecraft.potted_crimson_roots": "Dibçəkli al köklər",
  "block.minecraft.potted_dandelion": "Zəncirotu Dibçəyi",
  "block.minecraft.potted_dark_oak_sapling": "Qara Palıd Fidanı Saxsısı",
  "block.minecraft.potted_dead_bush": "Dibçəkli Ölü Bitki",
  "block.minecraft.potted_fern": "Qıjı Dibçəyi",
  "block.minecraft.potted_flowering_azalea_bush": "Dibçəkli çiçəkləyən azaliya",
  "block.minecraft.potted_golden_dandelion": "Qızıl Zəncirotu Saxsısı",
  "block.minecraft.potted_jungle_sapling": "Cəngəllik Ağacı Fidanı Saxsısı",
  "block.minecraft.potted_lily_of_the_valley": "İnciçiçəyi-da bir qazan",
  "block.minecraft.potted_mangrove_propagule": "Dibçəkli manqrov fidanı",
  "block.minecraft.potted_oak_sapling": "Palıd Fidanı Saxsısı",
  "block.minecraft.potted_open_eyeblossom": "Saksıda Açıq Göz Çiçəyi",
  "block.minecraft.potted_orange_tulip": "Narıncı Lalə Saxsısı",
  "block.minecraft.potted_oxeye_daisy": "Dibçəkli Çobanyastığı",
  "block.minecraft.potted_pale_oak_sapling": "Saxsıda Ağ Palıd Şitilı",
  "block.minecraft.potted_pink_tulip": "Dibçəkli Çəhrayı Lalə",
  "block.minecraft.potted_poppy": "Dibçəkli Lalə",
  "block.minecraft.potted_red_mushroom": "Qırmızı Göbələk Saxsısı",
  "block.minecraft.potted_red_tulip": "Qırmızı Lalə Saxsısı",
  "block.minecraft.potted_spruce_sapling": "Ladin Fidanı Saxsısı",
  "block.minecraft.potted_torchflower": "Saxsı Məşəl Çiçəyi",
  "block.minecraft.potted_warped_fungus": "Dibçəkli əyri göbələk",
  "block.minecraft.potted_warped_roots": "Dibçəkli əyri köklər",
  "block.minecraft.potted_white_tulip": "Dibçəkli Ağ Lalə",
  "block.minecraft.potted_wither_rose": "Dibçəkli Vizer Gülü",
  "block.minecraft.powder_snow": "Tozlu qar",
  "block.minecraft.powder_snow_cauldron": "Tozlu qar qazanı",
  "block.minecraft.powered_rail": "Gücləndirilmiş Rels",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarin kərpici pillə",
  "block.minecraft.prismarine_brick_stairs": "Prizmarin Kərpici Pilləkan",
  "block.minecraft.prismarine_bricks": "Prizmarin Kərpici",
  "block.minecraft.prismarine_slab": "Prizmarin pillə",
  "block.minecraft.prismarine_stairs": "Prizmarin pilləkən",
  "block.minecraft.prismarine_wall": "Prizmarin divar",
  "block.minecraft.pumpkin": "Balqabaq",
  "block.minecraft.pumpkin_stem": "Balqabaq Sapı",
  "block.minecraft.purple_banner": "Bənövşəyi Bayraq",
  "block.minecraft.purple_bed": "Bənövşəyi çarpayı",
  "block.minecraft.purple_candle": "Bənövşəyi şam",
  "block.minecraft.purple_candle_cake": "Bənövşəyi şamlı tort",
  "block.minecraft.purple_carpet": "Bənövşəyi Xalça",
  "block.minecraft.purple_concrete": "Bənövşəyi Beton",
  "block.minecraft.purple_concrete_powder": "Bənövşəyi Sement",
  "block.minecraft.purple_glazed_terracotta": "Bənövşəyi Şirli Terrakotta",
  "block.minecraft.purple_shulker_box": "Bənövşəyi Shulker Qutusu",
  "block.minecraft.purple_stained_glass": "Bənövşəyi Rəngli Şüşə",
  "block.minecraft.purple_stained_glass_pane": "Bənovşəyi Rəngli İncə Şüşə",
  "block.minecraft.purple_terracotta": "Bənövşəyi terrakotta",
  "block.minecraft.purple_wool": "Bənovşəyi Yun",
  "block.minecraft.purpur_block": "Purpur Bloku",
  "block.minecraft.purpur_pillar": "Purpur Stün",
  "block.minecraft.purpur_slab": "Purpur Pillə",
  "block.minecraft.purpur_stairs": "Purpur Pilləkən",
  "block.minecraft.quartz_block": "Kvars Bloku",
  "block.minecraft.quartz_bricks": "Kvars kərpic",
  "block.minecraft.quartz_pillar": "Kvars sütun",
  "block.minecraft.quartz_slab": "Kvars Pillə",
  "block.minecraft.quartz_stairs": "Kvars Pilləkən",
  "block.minecraft.rail": "Rels",
  "block.minecraft.raw_copper_block": "Xam mis bloku",
  "block.minecraft.raw_gold_block": "Xam qızıl bloku",
  "block.minecraft.raw_iron_block": "Çiy Dəmir Bloku",
  "block.minecraft.red_banner": "Qırmızı Bayraq",
  "block.minecraft.red_bed": "Qırmızı Çarpayı",
  "block.minecraft.red_candle": "Qırmızı şam",
  "block.minecraft.red_candle_cake": "Qırmızı şamlı tort",
  "block.minecraft.red_carpet": "Qırmızı Xalça",
  "block.minecraft.red_concrete": "Qırmızı Beton",
  "block.minecraft.red_concrete_powder": "Qırmızı Sement",
  "block.minecraft.red_glazed_terracotta": "Qırmızı Şirli Terrakotta",
  "block.minecraft.red_mushroom": "Qırmızı Göbələk",
  "block.minecraft.red_mushroom_block": "Qırmızı Göbələk Bloku",
  "block.minecraft.red_nether_brick_slab": "Qırmızı Nezer kərpici pilləsi",
  "block.minecraft.red_nether_brick_stairs": "Qırmızı Nezer kərpici pilləkanı",
  "block.minecraft.red_nether_brick_wall": "Qırmızı Nezer kərpici divarı",
  "block.minecraft.red_nether_bricks": "Qırmızı Nether Kərpici",
  "block.minecraft.red_sand": "Qırmızı Qum",
  "block.minecraft.red_sandstone": "Qırmızı Qumdaşı",
  "block.minecraft.red_sandstone_slab": "Qırmızı Qumdaşı Pillə",
  "block.minecraft.red_sandstone_stairs": "Qırmızı Qumdaşı Pilləkən",
  "block.minecraft.red_sandstone_wall": "Qırmızı Qumdaşı Divar",
  "block.minecraft.red_shulker_box": "Qırmızı Shulker Qutusu",
  "block.minecraft.red_stained_glass": "Qırmızı Rəngli Şüşə",
  "block.minecraft.red_stained_glass_pane": "Qırmızı Rəngli İncə Şüşə",
  "block.minecraft.red_terracotta": "Qırmızı Terrakotta",
  "block.minecraft.red_tulip": "Qırmızı Lalə",
  "block.minecraft.red_wool": "Qırmızı Yun",
  "block.minecraft.redstone_block": "Qızıl Daş Bloku",
  "block.minecraft.redstone_lamp": "Qızıl Daş Lampası",
  "block.minecraft.redstone_ore": "Qızıl Daş Filizi",
  "block.minecraft.redstone_torch": "Qızıl Daş Məşəli",
  "block.minecraft.redstone_wall_torch": "Kızıltaş Duvar Meşalesi",
  "block.minecraft.redstone_wire": "Qırmızı daş simi",
  "block.minecraft.reinforced_deepslate": "Gücləndirilmiş dərinlik",
  "block.minecraft.repeater": "Qızıl Daş Təzələyici",
  "block.minecraft.repeating_command_block": "Təkrarlayan Əmr Bloku",
  "block.minecraft.resin_block": "Qatran bloku",
  "block.minecraft.resin_brick_slab": "Qatran Kərpic Pilləsi",
  "block.minecraft.resin_brick_stairs": "Qatran Kərpic Pilləsi",
  "block.minecraft.resin_brick_wall": "Qatran Kərpic Divarı",
  "block.minecraft.resin_bricks": "Qatran Kərpic",
  "block.minecraft.resin_clump": "Qatran Parçası",
  "block.minecraft.respawn_anchor": "Respaun mayakı",
  "block.minecraft.rooted_dirt": "Köklü torpaq",
  "block.minecraft.rose_bush": "Qızılgül Kolu",
  "block.minecraft.sand": "Qum",
  "block.minecraft.sandstone": "Qumdaşı",
  "block.minecraft.sandstone_slab": "Qumdaşı Pillə",
  "block.minecraft.sandstone_stairs": "Qumdaşı Pilləkən",
  "block.minecraft.sandstone_wall": "Qumdaşı Divar",
  "block.minecraft.scaffolding": "Səhnəyə",
  "block.minecraft.sculk": "Skalk",
  "block.minecraft.sculk_catalyst": "Skalk Katalizörü",
  "block.minecraft.sculk_sensor": "Skalk sensoru",
  "block.minecraft.sculk_shrieker": "Qışqıran skalk",
  "block.minecraft.sculk_vein": "Skalk damarı",
  "block.minecraft.sea_lantern": "Dəniz Fənəri",
  "block.minecraft.sea_pickle": "Dəniz xiyarı",
  "block.minecraft.seagrass": "Dəniz Otu",
  "block.minecraft.set_spawn": "Respawn nöqtəsi təyin olundu",
  "block.minecraft.short_dry_grass": "Qısa Quru Ot",
  "block.minecraft.short_grass": "Qısa Ot",
  "block.minecraft.shroomlight": "Göbələk lampası",
  "block.minecraft.shulker_box": "Shulker Qutusu",
  "block.minecraft.skeleton_skull": "Skelet Kəlləsi",
  "block.minecraft.skeleton_wall_skull": "Skelet başı",
  "block.minecraft.slime_block": "Palçıq Bloku",
  "block.minecraft.small_amethyst_bud": "Kiçik ametist tumurcuğu",
  "block.minecraft.small_dripleaf": "Kiçik damcıyarpaq",
  "block.minecraft.smithing_table": "Dəmirçi Masası",
  "block.minecraft.smoker": "Şəhərim:",
  "block.minecraft.smooth_basalt": "Hamar bazalt",
  "block.minecraft.smooth_quartz": "Hamar kvars bloku",
  "block.minecraft.smooth_quartz_slab": "Düzgün Kvars Pillə",
  "block.minecraft.smooth_quartz_stairs": "Hamar Kvars Pilləkən",
  "block.minecraft.smooth_red_sandstone": "Düzgün Qırmızı Qumdaşı",
  "block.minecraft.smooth_red_sandstone_slab": "Düzgün Qırmızı Qumdaşı Pillə",
  "block.minecraft.smooth_red_sandstone_stairs": "Düzgün Qırmızı Qumdaşı Pilləkən",
  "block.minecraft.smooth_sandstone": "Düzgün Qumdaşı",
  "block.minecraft.smooth_sandstone_slab": "Düzgün Qumdaşı Pillə",
  "block.minecraft.smooth_sandstone_stairs": "Hamar Qumdaşı Pilləkən",
  "block.minecraft.smooth_stone": "Hamar daş",
  "block.minecraft.smooth_stone_slab": "Düzgün Daş Pillə",
  "block.minecraft.sniffer_egg": "Sniffer Yumurta",
  "block.minecraft.snow": "Qar",
  "block.minecraft.snow_block": "Qar Bloku",
  "block.minecraft.soul_campfire": "Ruh tonqalı",
  "block.minecraft.soul_fire": "Ruh alovu",
  "block.minecraft.soul_lantern": "Ruh Fənəri",
  "block.minecraft.soul_sand": "Ruh Qumu",
  "block.minecraft.soul_soil": "Ruh torpağı",
  "block.minecraft.soul_torch": "Ruh məşəli",
  "block.minecraft.soul_wall_torch": "Ruh divarı məşəli",
  "block.minecraft.spawn.not_valid": "Eviniz və ya yüklü yenidən yaranma lövbəriniz yoxdur və ya məhv edilib",
  "block.minecraft.spawner": "Canavar Törədici",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Mob Tipini təyin edir",
  "block.minecraft.sponge": "Süngər",
  "block.minecraft.spore_blossom": "Spor çiçəyi",
  "block.minecraft.spruce_button": "Ladin Düymə",
  "block.minecraft.spruce_door": "Ladin Qapı",
  "block.minecraft.spruce_fence": "Ladin Çəpər",
  "block.minecraft.spruce_fence_gate": "Ladin Çəpər Qapısı",
  "block.minecraft.spruce_hanging_sign": "Ladin Asma İşarəsi",
  "block.minecraft.spruce_leaves": "Ladin Yarpaqları",
  "block.minecraft.spruce_log": "Küknar kötüyü",
  "block.minecraft.spruce_planks": "Ladin Taxta",
  "block.minecraft.spruce_pressure_plate": "Ladin Təyziq Təbəqəsi",
  "block.minecraft.spruce_sapling": "Ladin Fidanı",
  "block.minecraft.spruce_shelf": "Ladin Rəf",
  "block.minecraft.spruce_sign": "Ladin Lövhə",
  "block.minecraft.spruce_slab": "Ladin Pillə",
  "block.minecraft.spruce_stairs": "Ladin Pilləkən",
  "block.minecraft.spruce_trapdoor": "Ladin Tələ Qapısı",
  "block.minecraft.spruce_wall_hanging_sign": "Divarda Asma Nişanı",
  "block.minecraft.spruce_wall_sign": "Divarda Ladin Lövhə",
  "block.minecraft.spruce_wood": "Küknar odunu",
  "block.minecraft.sticky_piston": "Yapışqan Piston",
  "block.minecraft.stone": "Daş",
  "block.minecraft.stone_brick_slab": "Daş Kərpic Pillə",
  "block.minecraft.stone_brick_stairs": "Daş Kərpic Pilləkən",
  "block.minecraft.stone_brick_wall": "Daş Kərpic Divar",
  "block.minecraft.stone_bricks": "Daş Kərpic",
  "block.minecraft.stone_button": "Daş Düymə",
  "block.minecraft.stone_pressure_plate": "Daş Təyziq Təbəqəsi",
  "block.minecraft.stone_slab": "Daş Pillə",
  "block.minecraft.stone_stairs": "Daş Pilləkən",
  "block.minecraft.stonecutter": "Daşkəsən",
  "block.minecraft.stripped_acacia_log": "Soyulmuş akasiya kötüyü",
  "block.minecraft.stripped_acacia_wood": "Soyulmuş Akasya Kütüğü",
  "block.minecraft.stripped_bamboo_block": "Soyulmuş Bambuk Bloku",
  "block.minecraft.stripped_birch_log": "Soyulmuş ağcaqayın kötüyü",
  "block.minecraft.stripped_birch_wood": "Soyulmuş Huş Kütüğü",
  "block.minecraft.stripped_cherry_log": "Soyulmuş Albalı Girişi",
  "block.minecraft.stripped_cherry_wood": "Soyulmuş Albalı Ağacı",
  "block.minecraft.stripped_crimson_hyphae": "Soyulmuş al hifa",
  "block.minecraft.stripped_crimson_stem": "Soyulmuş al saplaq",
  "block.minecraft.stripped_dark_oak_log": "Soyulmuş Qara Palıd Kötüyü",
  "block.minecraft.stripped_dark_oak_wood": "Soyulmuş Qara Palıd Odunu",
  "block.minecraft.stripped_jungle_log": "Soyulmuş cəngəllik kötüyü",
  "block.minecraft.stripped_jungle_wood": "Soyulmuş Orman Ağacı Kütüğü",
  "block.minecraft.stripped_mangrove_log": "Soyulmuş Manqrov Kötüyü",
  "block.minecraft.stripped_mangrove_wood": "Soyulmuş Manqrov Odunu",
  "block.minecraft.stripped_oak_log": "Soyulmuş Palıd Kötüyü",
  "block.minecraft.stripped_oak_wood": "Soyulmuş Palıd Odunu",
  "block.minecraft.stripped_pale_oak_log": "Soyulmuş Ağ Palıd Odunu",
  "block.minecraft.stripped_pale_oak_wood": "Soyulmuş Solğun Palıd Taxta",
  "block.minecraft.stripped_spruce_log": "Soyulmuş küknar kötüyü",
  "block.minecraft.stripped_spruce_wood": "Soyulmuş küknar kötüyü",
  "block.minecraft.stripped_warped_hyphae": "Stripped Warped Hyphae",
  "block.minecraft.stripped_warped_stem": "Soyulmuş əyri saplaq",
  "block.minecraft.structure_block": "Struktur Bloku",
  "block.minecraft.structure_void": "Struktur Boşluğu",
  "block.minecraft.sugar_cane": "Şəkərqamışı",
  "block.minecraft.sunflower": "Günəbaxan",
  "block.minecraft.suspicious_gravel": "Şübhəli çınqıl",
  "block.minecraft.suspicious_sand": "Şübhəli Qum",
  "block.minecraft.sweet_berry_bush": "Şirin giləmeyvə kol",
  "block.minecraft.tall_dry_grass": "Uzun Quru Ot",
  "block.minecraft.tall_grass": "Uzun Ot",
  "block.minecraft.tall_seagrass": "Uzun Dəniz Otu",
  "block.minecraft.target": "Hədəf",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Sınaq Bloku",
  "block.minecraft.test_instance_block": "Sınaq Nümunə Bloku",
  "block.minecraft.tinted_glass": "Rəngli şüşə",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT partlayışları deaktiv edilib",
  "block.minecraft.torch": "Məşəl",
  "block.minecraft.torchflower": "Məşəl çiçəyi",
  "block.minecraft.torchflower_crop": "Məşəl çiçəyi məhsulu",
  "block.minecraft.trapped_chest": "Tələli Sandıq",
  "block.minecraft.trial_spawner": "Sınaq Kəpənəyi",
  "block.minecraft.tripwire": "Tələ İpi",
  "block.minecraft.tripwire_hook": "Tələ Qarmağı",
  "block.minecraft.tube_coral": "Boru mərcan",
  "block.minecraft.tube_coral_block": "Boru mərcan bloku",
  "block.minecraft.tube_coral_fan": "Bubble Coral Fan",
  "block.minecraft.tube_coral_wall_fan": "Boru mərcan divarı",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tuf kərpic pilləs",
  "block.minecraft.tuff_brick_stairs": "Tuf kərpic pilləkənləri",
  "block.minecraft.tuff_brick_wall": "Tuf kərpic divar",
  "block.minecraft.tuff_bricks": "Tuf kərpicləri",
  "block.minecraft.tuff_slab": "Tuf Pilləs",
  "block.minecraft.tuff_stairs": "Tüf pilləkənləri",
  "block.minecraft.tuff_wall": "Tüf divarı",
  "block.minecraft.turtle_egg": "Tısbağa yumurtası",
  "block.minecraft.twisting_vines": "Burulmuş sarmaşıq",
  "block.minecraft.twisting_vines_plant": "Burulmuş sarmaşıq bitkisi",
  "block.minecraft.vault": "Tonoz",
  "block.minecraft.verdant_froglight": "Yaşıl qurbağaişıq",
  "block.minecraft.vine": "Sarmaşıq",
  "block.minecraft.void_air": "Boşluq havası",
  "block.minecraft.wall_torch": "Divar məşəli",
  "block.minecraft.warped_button": "Korlanmış düymə",
  "block.minecraft.warped_door": "Korlanmış qapı",
  "block.minecraft.warped_fence": "Əyri Çəpər",
  "block.minecraft.warped_fence_gate": "Əyri Çəpər Qapısı",
  "block.minecraft.warped_fungus": "Əyri göbələk",
  "block.minecraft.warped_hanging_sign": "Əzilmiş Asma İşarəsi",
  "block.minecraft.warped_hyphae": "Əyri hifalar",
  "block.minecraft.warped_nylium": "Əyri nilium",
  "block.minecraft.warped_planks": "Əyri taxta",
  "block.minecraft.warped_pressure_plate": "Əyri təzyiq lövhəsi",
  "block.minecraft.warped_roots": "Əyri köklər",
  "block.minecraft.warped_shelf": "Korlanmış rəf",
  "block.minecraft.warped_sign": "Əyri lövhə",
  "block.minecraft.warped_slab": "Əyri pillə",
  "block.minecraft.warped_stairs": "Əyri Pilləkən",
  "block.minecraft.warped_stem": "Əyri saplaq",
  "block.minecraft.warped_trapdoor": "Əyri tələ qapısı",
  "block.minecraft.warped_wall_hanging_sign": "Əzilmiş Divar Asma Nişanı",
  "block.minecraft.warped_wall_sign": "Çarpan divar işarəsi",
  "block.minecraft.warped_wart_block": "Əyri ziyil bloku",
  "block.minecraft.water": "Su",
  "block.minecraft.water_cauldron": "Su Qazanı",
  "block.minecraft.waxed_chiseled_copper": "Mumla işlənmiş mis",
  "block.minecraft.waxed_copper_bars": "Mumlu Mi",
  "block.minecraft.waxed_copper_block": "Mumlanmış mis bloku",
  "block.minecraft.waxed_copper_bulb": "Mumlu Mis Lampa",
  "block.minecraft.waxed_copper_chain": "Cilalı Mis Zincir",
  "block.minecraft.waxed_copper_chest": "Cilalı Mis Sandıq",
  "block.minecraft.waxed_copper_door": "Mumlu Mis Qapı",
  "block.minecraft.waxed_copper_golem_statue": "Cilalı Mis Qolem Heykəli",
  "block.minecraft.waxed_copper_grate": "Mumlu Mis Barmaqlıq",
  "block.minecraft.waxed_copper_lantern": "Cilalı Mis Fənər",
  "block.minecraft.waxed_copper_trapdoor": "Mumlu Mis Tələ Qapısı",
  "block.minecraft.waxed_cut_copper": "Mumlanmış kəsilmiş mis",
  "block.minecraft.waxed_cut_copper_slab": "Mumlanmış kəsilmiş mis pillə",
  "block.minecraft.waxed_cut_copper_stairs": "Mumlanmış Kəsilmiş Mis Pilləkən",
  "block.minecraft.waxed_exposed_chiseled_copper": "Mumlu Açıq Kəsilmiş Mis",
  "block.minecraft.waxed_exposed_copper": "Mumlu müdafiəsiz qalmış mis",
  "block.minecraft.waxed_exposed_copper_bars": "Cilalı Açıqda Qalmış Mis Barmaqlıq",
  "block.minecraft.waxed_exposed_copper_bulb": "Mumlu oksidləşdirilmiş mis lampa",
  "block.minecraft.waxed_exposed_copper_chain": "Cilalı Açıqda Qalmış Mis Zincir",
  "block.minecraft.waxed_exposed_copper_chest": "Cilalı Açıqda Qalmış Mis Sandıq",
  "block.minecraft.waxed_exposed_copper_door": "Mumlu oksidləşdirilmiş mis lampa",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Mumlu Açıqda Qalmış Mis Qolem Heykəli",
  "block.minecraft.waxed_exposed_copper_grate": "Mumlu Açıq Mis Barmaqlıq",
  "block.minecraft.waxed_exposed_copper_lantern": "Cilalı Açıqda Qalmış Mis Fənər",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Mumlu Açıq Mis Qapı",
  "block.minecraft.waxed_exposed_cut_copper": "Mumlu müdafiəsiz qalmış kəsilmiş mis",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Mumlu müdafiəsiz qalmış kəsilmiş mis pillə",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Mumlu müdafiəsiz qalmış kəsilmiş mis pilləkən",
  "block.minecraft.waxed_exposed_lightning_rod": "Cilalı Açıqda Qalmış İldırım Çubuğu",
  "block.minecraft.waxed_lightning_rod": "Cilalı İldırım Çubuğu",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Mumlu Oksidləşdirilmiş Yonmuş Mis",
  "block.minecraft.waxed_oxidized_copper": "Mumlanmış okdisləşmiş mis",
  "block.minecraft.waxed_oxidized_copper_bars": "Cilalı Oksidlənmiş Mis Barmaqlıq",
  "block.minecraft.waxed_oxidized_copper_bulb": "Mumlu oksidləşdirilmiş mis lampa",
  "block.minecraft.waxed_oxidized_copper_chain": "Cilalı Oksidlənmiş Mis Zincir",
  "block.minecraft.waxed_oxidized_copper_chest": "Cilalı Oksidlənmiş Mis Sandıq",
  "block.minecraft.waxed_oxidized_copper_door": "Mumlu Oksidləşdirilmiş Mis Qapı",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Cilalı Oksidlənmiş Mis Qolem Heykəli",
  "block.minecraft.waxed_oxidized_copper_grate": "Mumlu oksidləşmiş mis ızgarası",
  "block.minecraft.waxed_oxidized_copper_lantern": "Cilalı Oksidlənmiş Mis Fənər",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Mumlu Oksidləşdirilmiş Mis Qapağı",
  "block.minecraft.waxed_oxidized_cut_copper": "Mumlanmış oksidləşmiş kəsilmiş mis",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Mumlanmış oksidləşmiş kəsilmiş mis pillə",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Mumlanmış okdisləşmiş kəsilmiş mis pilləkən",
  "block.minecraft.waxed_oxidized_lightning_rod": "Cilalı Oksidlənmiş İldırım Çubuğu",
  "block.minecraft.waxed_weathered_chiseled_copper": "Balmumu ilə işlənmiş kəsilmiş mis",
  "block.minecraft.waxed_weathered_copper": "Mumlu solmuş mis",
  "block.minecraft.waxed_weathered_copper_bars": "Cilalı Yıpradılmış Mis Barmaqlıq",
  "block.minecraft.waxed_weathered_copper_bulb": "Balmumu ilə işlənmiş mis lampa",
  "block.minecraft.waxed_weathered_copper_chain": "Cilalı Yıpradılmış Mis Zincir",
  "block.minecraft.waxed_weathered_copper_chest": "Cilalı Yıpradılmış Mis Sandıq",
  "block.minecraft.waxed_weathered_copper_door": "Balmumu ilə işlənmiş Mis Qapı",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Cilalı Yıpradılmış Mis Qolem Heykəli",
  "block.minecraft.waxed_weathered_copper_grate": "Balmumu ilə işlənmiş mis ızgara",
  "block.minecraft.waxed_weathered_copper_lantern": "Cilalı Yıpradılmış Mis Fənər",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Balmumu ilə işlənmiş Mis Qapı",
  "block.minecraft.waxed_weathered_cut_copper": "Mumlu solmuş kəsilmiş mis",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Mumlu solmuş kəsilmiş mis pillə",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Mumlu solmuş kəsilmiş mis pilləkən",
  "block.minecraft.waxed_weathered_lightning_rod": "Cilalı Yıpradılmış İldırım Çubuğu",
  "block.minecraft.weathered_chiseled_copper": "Aşınmış zərb edilmiş mis",
  "block.minecraft.weathered_copper": "Solmuş mis",
  "block.minecraft.weathered_copper_bars": "Yıpradılmış Mis Barmaqlıq",
  "block.minecraft.weathered_copper_bulb": "İşlənmiş Mis Lampa",
  "block.minecraft.weathered_copper_chain": "Yıpradılmış Mis Zincir",
  "block.minecraft.weathered_copper_chest": "Yıpradılmış Mis Sandıq",
  "block.minecraft.weathered_copper_door": "İşlənmiş Mis Qapı",
  "block.minecraft.weathered_copper_golem_statue": "Yıpradılmış Mis Qolem Heykəli",
  "block.minecraft.weathered_copper_grate": "İşlənmiş Mis Barmaqlıq",
  "block.minecraft.weathered_copper_lantern": "Yıpradılmış Mis Fənər",
  "block.minecraft.weathered_copper_trapdoor": "İşlənmiş Mis Qapı",
  "block.minecraft.weathered_cut_copper": "Solmuş kəsilmiş mis",
  "block.minecraft.weathered_cut_copper_slab": "Solmuş kəsilmiş mis pillə",
  "block.minecraft.weathered_cut_copper_stairs": "Solmuş Kəsilmiş Mis Pilləkən",
  "block.minecraft.weathered_lightning_rod": "Yıpradılmış İldırım Çubuğu",
  "block.minecraft.weeping_vines": "Ağlayan sarmaşıq",
  "block.minecraft.weeping_vines_plant": "Ağlayan sarmaşıq bitkisi",
  "block.minecraft.wet_sponge": "İslaq Süngər",
  "block.minecraft.wheat": "Buğda əkini",
  "block.minecraft.white_banner": "Ağ Bayraq",
  "block.minecraft.white_bed": "Ağ çarpayı",
  "block.minecraft.white_candle": "Ağ Şam",
  "block.minecraft.white_candle_cake": "Ağ şamlı tort",
  "block.minecraft.white_carpet": "Ağ Xalça",
  "block.minecraft.white_concrete": "Ağ Beton",
  "block.minecraft.white_concrete_powder": "Ağ Sement",
  "block.minecraft.white_glazed_terracotta": "Ağ Şirli Terrakotta",
  "block.minecraft.white_shulker_box": "Ağ Shulker Qutusu",
  "block.minecraft.white_stained_glass": "Ağ Rəngli Şüşə",
  "block.minecraft.white_stained_glass_pane": "Ağ Rəngli İncə Şüşə",
  "block.minecraft.white_terracotta": "Ağ terrakotta",
  "block.minecraft.white_tulip": "Ağ Lalə",
  "block.minecraft.white_wool": "Ağ Yun",
  "block.minecraft.wildflowers": "Yabanı Gül",
  "block.minecraft.wither_rose": "Wither Gülü",
  "block.minecraft.wither_skeleton_skull": "Wither Skeleti Kəlləsi",
  "block.minecraft.wither_skeleton_wall_skull": "Vizer Skelet başı",
  "block.minecraft.yellow_banner": "Sarı Bayraq",
  "block.minecraft.yellow_bed": "Sarı çarpayı",
  "block.minecraft.yellow_candle": "Sarı Şam",
  "block.minecraft.yellow_candle_cake": "Sarı şam ilə tort",
  "block.minecraft.yellow_carpet": "Sarı Xalça",
  "block.minecraft.yellow_concrete": "Sarı Beton",
  "block.minecraft.yellow_concrete_powder": "Sarı Sement",
  "block.minecraft.yellow_glazed_terracotta": "Sarı şirli terrakotta",
  "block.minecraft.yellow_shulker_box": "Sarı Shulker Qutusu",
  "block.minecraft.yellow_stained_glass": "Sarı Rəngli Şüşə",
  "block.minecraft.yellow_stained_glass_pane": "Sarı Rəngli İncə Şüşə",
  "block.minecraft.yellow_terracotta": "Sarı terrakotta",
  "block.minecraft.yellow_wool": "Sarı Yun",
  "block.minecraft.zombie_head": "Zombi Başı",
  "block.minecraft.zombie_wall_head": "Zombi Başı",
  "item.minecraft.acacia_boat": "Akasiya Qayıq",
  "item.minecraft.acacia_chest_boat": "Sandıqlı Akasiya Qayıq",
  "item.minecraft.allay_spawn_egg": "Kürü Yumurtasını Allay",
  "item.minecraft.amethyst_shard": "Ametist parçası",
  "item.minecraft.angler_pottery_shard": "Balıqçı Saxsı Parçası",
  "item.minecraft.angler_pottery_sherd": "Balıqçı dulusçuluq qabığı",
  "item.minecraft.apple": "Alma",
  "item.minecraft.archer_pottery_shard": "Oxatan dulusçuluq parçası",
  "item.minecraft.archer_pottery_sherd": "Oxatan dulusçuluq qabı",
  "item.minecraft.armadillo_scute": "Armadillo pulu",
  "item.minecraft.armadillo_spawn_egg": "Armadillo çağırma yumurtası",
  "item.minecraft.armor_stand": "Zireh stendi",
  "item.minecraft.arms_up_pottery_shard": "Dulusçuluq parçasını silahlandırın",
  "item.minecraft.arms_up_pottery_sherd": "Dulusçuluq qabını silahlandırın",
  "item.minecraft.arrow": "Ox",
  "item.minecraft.axolotl_bucket": "Aksolotl vedrəsi",
  "item.minecraft.axolotl_spawn_egg": "Aksolotl spaun yumurtası",
  "item.minecraft.baked_potato": "Bişmiş Kartof",
  "item.minecraft.bamboo_chest_raft": "Sinə ilə bambuk sal",
  "item.minecraft.bamboo_raft": "Bambuk sal",
  "item.minecraft.bat_spawn_egg": "Yarasa çağırma yumurtası",
  "item.minecraft.bee_spawn_egg": "Arı çağırma yumurtası",
  "item.minecraft.beef": "Çiy İnək Əti",
  "item.minecraft.beetroot": "Çuğundur",
  "item.minecraft.beetroot_seeds": "Çuğundur Toxumu",
  "item.minecraft.beetroot_soup": "Çuğundur Şorbası",
  "item.minecraft.birch_boat": "Ağcaqayın Qayıq",
  "item.minecraft.birch_chest_boat": "Sandıqlı Ağcaqayın Qayıq",
  "item.minecraft.black_bundle": "qara kəsə",
  "item.minecraft.black_dye": "Qara Boya",
  "item.minecraft.black_harness": "Qara Yəhər",
  "item.minecraft.blade_pottery_shard": "Bıçaqlı dulusçuluq parçası",
  "item.minecraft.blade_pottery_sherd": "Bıçaqlı dulusçuluq parçası",
  "item.minecraft.blaze_powder": "İfrit Tozu",
  "item.minecraft.blaze_rod": "İfrit Çubuğu",
  "item.minecraft.blaze_spawn_egg": "İfrit çağırma yumurtası",
  "item.minecraft.blue_bundle": "Mavi Şam",
  "item.minecraft.blue_dye": "Göy Boya",
  "item.minecraft.blue_egg": "Mavi Yumurta",
  "item.minecraft.blue_harness": "Göy Qoşqu",
  "item.minecraft.bogged_spawn_egg": "Bataq Çağırma Yumurtası",
  "item.minecraft.bolt_armor_trim_smithing_template": "Dəmirçilik Şablonu",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "İldırım Zireh Modeli",
  "item.minecraft.bone": "Sümük",
  "item.minecraft.bone_meal": "Sümük Tozu",
  "item.minecraft.book": "Kitab",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Yay",
  "item.minecraft.bowl": "Qab",
  "item.minecraft.bread": "Çörək",
  "item.minecraft.breeze_rod": "İfrit Çubuğu",
  "item.minecraft.breeze_spawn_egg": "İfrit çağırma yumurtası",
  "item.minecraft.brewer_pottery_shard": "Pivə qabı qabığı",
  "item.minecraft.brewer_pottery_sherd": "Pivə Saxsı Parçası",
  "item.minecraft.brewing_stand": "İksir Dəzgahı",
  "item.minecraft.brick": "Kərpic",
  "item.minecraft.brown_bundle": "Qəhvəyi Şam",
  "item.minecraft.brown_dye": "Qəhvəyi Boya",
  "item.minecraft.brown_egg": "Qəhvəyi Yumurta",
  "item.minecraft.brown_harness": "Qəhvəyi Yəhər",
  "item.minecraft.brush": "Fırça",
  "item.minecraft.bucket": "Vedrə",
  "item.minecraft.bundle": "Boğça",
  "item.minecraft.bundle.empty": "Boş",
  "item.minecraft.bundle.empty.description": "Qarışıq əşyalardam bir yığım daşıya bilər",
  "item.minecraft.bundle.full": "Dolu",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Dulusçuluq parçasını yandırın",
  "item.minecraft.burn_pottery_sherd": "Saxsı qabı yandırın",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Dəvə Kürü Yumurtası",
  "item.minecraft.carrot": "Yerkökü",
  "item.minecraft.carrot_on_a_stick": "Yerkökü Tilovu",
  "item.minecraft.cat_spawn_egg": "Pişik çağırma yumurtası",
  "item.minecraft.cauldron": "Qazan",
  "item.minecraft.cave_spider_spawn_egg": "Mağara hörümcəyi çağırma yumurtası",
  "item.minecraft.chainmail_boots": "Zəncir Çəkmə",
  "item.minecraft.chainmail_chestplate": "Zəncir Sinəlik",
  "item.minecraft.chainmail_helmet": "Zəncir Dəbilqə",
  "item.minecraft.chainmail_leggings": "Zəncir Şalvar",
  "item.minecraft.charcoal": "Odun Kömürü",
  "item.minecraft.cherry_boat": "Albalı qayığı",
  "item.minecraft.cherry_chest_boat": "Sinə ilə albalı qayıq",
  "item.minecraft.chest_minecart": "Sandıqlı Vaqon",
  "item.minecraft.chicken": "Çiy Toyuq Əti",
  "item.minecraft.chicken_spawn_egg": "Toyuq çağırma yumurtası",
  "item.minecraft.chorus_fruit": "Nəqarət Meyvəsi",
  "item.minecraft.clay_ball": "Gil topu",
  "item.minecraft.clock": "Saat",
  "item.minecraft.coal": "Kömür",
  "item.minecraft.coast_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Sahil Zireh Modeli",
  "item.minecraft.cocoa_beans": "Kakao Dənələri",
  "item.minecraft.cod": "Çiy Treska",
  "item.minecraft.cod_bucket": "Treska Vedrəsi",
  "item.minecraft.cod_spawn_egg": "Treska çağırma yumurtası",
  "item.minecraft.command_block_minecart": "Əmr Bloklu Vaqon",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Bifşteks",
  "item.minecraft.cooked_chicken": "Bişmiş Toyuq Əti",
  "item.minecraft.cooked_cod": "Bişmiş Treska",
  "item.minecraft.cooked_mutton": "Bişmiş Qoyun Əti",
  "item.minecraft.cooked_porkchop": "Bişmiş Donuz Əti",
  "item.minecraft.cooked_rabbit": "Bişmiş Dovşan Əti",
  "item.minecraft.cooked_salmon": "Bişmiş Salmon",
  "item.minecraft.cookie": "Kökə",
  "item.minecraft.copper_axe": "Mis balta",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Mis dəbilqə",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Mis Külçə",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Mis külüng",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Mis nizə",
  "item.minecraft.copper_sword": "Mis qılınc",
  "item.minecraft.cow_spawn_egg": "İnək çağırma yumurtası",
  "item.minecraft.creaking_spawn_egg": "Cırıldayan Çağırma Yumurtası",
  "item.minecraft.creeper_banner_pattern": "Banner şablonu",
  "item.minecraft.creeper_banner_pattern.desc": "Kriper şəkli",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Şarj Bayraq modeli",
  "item.minecraft.creeper_spawn_egg": "Kriper çağırma yumurtası",
  "item.minecraft.crossbow": "Arbalet",
  "item.minecraft.crossbow.projectile": "Avadanlıq:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyektil: %s",
  "item.minecraft.cyan_bundle": "Mavi Boğça",
  "item.minecraft.cyan_dye": "Mavi Boya",
  "item.minecraft.cyan_harness": "Mavi Yəhər",
  "item.minecraft.danger_pottery_shard": "Təhlükəli dulusçuluq parçası",
  "item.minecraft.danger_pottery_sherd": "Təhlükəli dulusçuluq qabı",
  "item.minecraft.dark_oak_boat": "Qara Palıd Qayıq",
  "item.minecraft.dark_oak_chest_boat": "Sandıqlı Qara Palıd Qayıq",
  "item.minecraft.debug_stick": "Xəta Tapma Çubuğu",
  "item.minecraft.debug_stick.empty": "%s xüsusiyyətsizdir",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) seçilib",
  "item.minecraft.debug_stick.update": "\"%%n\" üçün \"%%n\"\n",
  "item.minecraft.diamond": "Almaz",
  "item.minecraft.diamond_axe": "Almaz Balta",
  "item.minecraft.diamond_boots": "Almaz çəkmə",
  "item.minecraft.diamond_chestplate": "Almaz Sinəlik",
  "item.minecraft.diamond_helmet": "Almaz Dəbilqə",
  "item.minecraft.diamond_hoe": "Almaz Kərki",
  "item.minecraft.diamond_horse_armor": "Almaz At Zirehi",
  "item.minecraft.diamond_leggings": "Almaz şalvar",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Almaz Qazma",
  "item.minecraft.diamond_shovel": "Almaz Kürək",
  "item.minecraft.diamond_spear": "Almaz nizə",
  "item.minecraft.diamond_sword": "Almaz Qılınc",
  "item.minecraft.disc_fragment_5": "Disk Fraqmenti",
  "item.minecraft.disc_fragment_5.desc": "Musiqi Diski - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin çağırma yumurtası",
  "item.minecraft.donkey_spawn_egg": "Uzunqulaq çağırma yumurtası",
  "item.minecraft.dragon_breath": "Əjdaha Nəfəsi",
  "item.minecraft.dried_kelp": "Qurudulmuş Yosun",
  "item.minecraft.drowned_spawn_egg": "Boğulmuş çağırma yumurtası",
  "item.minecraft.dune_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Çöl Zireh Modeli",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Yumurta",
  "item.minecraft.elder_guardian_spawn_egg": "Yaşlı mühafizəçi çağırma yumurtası",
  "item.minecraft.elytra": "Qanadüstü",
  "item.minecraft.emerald": "Zümrüd",
  "item.minecraft.enchanted_book": "Sehrli Kitab",
  "item.minecraft.enchanted_golden_apple": "Sehrli qızıl alma",
  "item.minecraft.end_crystal": "End Kristali",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Kürü Yumurtası",
  "item.minecraft.ender_eye": "Ender Gözü",
  "item.minecraft.ender_pearl": "Ender İncisi",
  "item.minecraft.enderman_spawn_egg": "Endermen çağırma yumurtası",
  "item.minecraft.endermite_spawn_egg": "Endermit çağırma yumurtası",
  "item.minecraft.evoker_spawn_egg": "Oyadıcı çağırma yumurtası",
  "item.minecraft.experience_bottle": "Təcrübə Eliksiri",
  "item.minecraft.explorer_pottery_shard": "Kəşfiyyatçı dulusçuluq parçası",
  "item.minecraft.explorer_pottery_sherd": "Kəşfiyyatçı dulusçuluq qabı",
  "item.minecraft.eye_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Göz Zireh Modeli",
  "item.minecraft.feather": "Tük",
  "item.minecraft.fermented_spider_eye": "Mayalı Hörümcək Gözü",
  "item.minecraft.field_masoned_banner_pattern": "Kərpic Bayraq Naxışı",
  "item.minecraft.filled_map": "Xəritə",
  "item.minecraft.fire_charge": "Alov Topu",
  "item.minecraft.firework_rocket": "Fişəng Raketi",
  "item.minecraft.firework_rocket.flight": "Uçuş Müddəti:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fişəng Ulduzu",
  "item.minecraft.firework_star.black": "Qara",
  "item.minecraft.firework_star.blue": "Göy",
  "item.minecraft.firework_star.brown": "Qəhvəyi",
  "item.minecraft.firework_star.custom_color": "Xüsusi",
  "item.minecraft.firework_star.cyan": "Mavi",
  "item.minecraft.firework_star.fade_to": "Keçiş Rəngi",
  "item.minecraft.firework_star.flicker": "Parıltı",
  "item.minecraft.firework_star.gray": "Boz",
  "item.minecraft.firework_star.green": "Yaşıl",
  "item.minecraft.firework_star.light_blue": "Açıq Göy",
  "item.minecraft.firework_star.light_gray": "Açıq Boz",
  "item.minecraft.firework_star.lime": "Açıq Yaşıl",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Narıncı",
  "item.minecraft.firework_star.pink": "Çəhrayı",
  "item.minecraft.firework_star.purple": "Bənövşəyi",
  "item.minecraft.firework_star.red": "Qırmızı",
  "item.minecraft.firework_star.shape": "Bilinməyən Şəkil",
  "item.minecraft.firework_star.shape.burst": "Partlama",
  "item.minecraft.firework_star.shape.creeper": "Creeper Şəkilli",
  "item.minecraft.firework_star.shape.large_ball": "Böyük top",
  "item.minecraft.firework_star.shape.small_ball": "Kiçik Top",
  "item.minecraft.firework_star.shape.star": "Ulduz Şəkilli",
  "item.minecraft.firework_star.trail": "İz",
  "item.minecraft.firework_star.white": "Ağ",
  "item.minecraft.firework_star.yellow": "Sarı",
  "item.minecraft.fishing_rod": "Tilov",
  "item.minecraft.flint": "Çaxmax Daşı",
  "item.minecraft.flint_and_steel": "Çaxmax Daşı və Polad",
  "item.minecraft.flow_armor_trim_smithing_template": "Dəmirçilik Şablonu",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Axış Zireh Modeli",
  "item.minecraft.flow_banner_pattern": "Bayraq Naxışı",
  "item.minecraft.flow_banner_pattern.desc": "Axış",
  "item.minecraft.flow_banner_pattern.new": "Axış Bayraq Naxışı",
  "item.minecraft.flow_pottery_sherd": "Axış Dulusçuluq Parçası",
  "item.minecraft.flower_banner_pattern": "Bayraq Modeli",
  "item.minecraft.flower_banner_pattern.desc": "Çiçək şəkli",
  "item.minecraft.flower_banner_pattern.new": "Gül Bayraq Naxışı",
  "item.minecraft.flower_pot": "Saxsı",
  "item.minecraft.fox_spawn_egg": "Tülkü çağırma yumurtası",
  "item.minecraft.friend_pottery_shard": "Dost dulusçuluq parçası",
  "item.minecraft.friend_pottery_sherd": "Dost dulusçuluq",
  "item.minecraft.frog_spawn_egg": "Qurbağa Çağırma Yumurtası",
  "item.minecraft.furnace_minecart": "Sobalı Vaqon",
  "item.minecraft.ghast_spawn_egg": "Qast çağırma yumurtası",
  "item.minecraft.ghast_tear": "Ghast Gözyaşı",
  "item.minecraft.glass_bottle": "Şüşə Butulka",
  "item.minecraft.glistering_melon_slice": "Parıldayan qapız dilimi",
  "item.minecraft.globe_banner_pattern": "Bayraq Modeli",
  "item.minecraft.globe_banner_pattern.desc": "Kürə",
  "item.minecraft.globe_banner_pattern.new": "Yer Kürəsi Bayraq Naxışı",
  "item.minecraft.glow_berries": "Parlaq giləmeyvələr",
  "item.minecraft.glow_ink_sac": "Parıldayan mürəkkəb kisəsi",
  "item.minecraft.glow_item_frame": "Parıldayan əşya çərçivəsi",
  "item.minecraft.glow_squid_spawn_egg": "Parıldayan osminoq spaun yumurtası",
  "item.minecraft.glowstone_dust": "İşıq Daşı Tozu",
  "item.minecraft.goat_horn": "Keçi Buynuzu",
  "item.minecraft.goat_spawn_egg": "Keçi spaun yumurtası",
  "item.minecraft.gold_ingot": "Qızıl Külçə",
  "item.minecraft.gold_nugget": "Qızıl Parçası",
  "item.minecraft.golden_apple": "Qızıl Alma",
  "item.minecraft.golden_axe": "Qızıl Balta",
  "item.minecraft.golden_boots": "Qızıl çəkmə",
  "item.minecraft.golden_carrot": "Qızıl Yerkökü",
  "item.minecraft.golden_chestplate": "Qızıl Sinəlik",
  "item.minecraft.golden_helmet": "Qızıl Dəbilqə",
  "item.minecraft.golden_hoe": "Qızıl Kərki",
  "item.minecraft.golden_horse_armor": "Qızıl at zirehi",
  "item.minecraft.golden_leggings": "Qızıl şalvar",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Qızıl Qazma",
  "item.minecraft.golden_shovel": "Qızıl Kürək",
  "item.minecraft.golden_spear": "Qızıl nizə",
  "item.minecraft.golden_sword": "Qızıl Qılınc",
  "item.minecraft.gray_bundle": "Boz Şam",
  "item.minecraft.gray_dye": "Boz Boya",
  "item.minecraft.gray_harness": "Boz Yəhər",
  "item.minecraft.green_bundle": "Yaşıl Şam",
  "item.minecraft.green_dye": "Yaşıl Boya",
  "item.minecraft.green_harness": "Yaşıl Yəhər",
  "item.minecraft.guardian_spawn_egg": "Mühafizəçi çağırma yumurtası",
  "item.minecraft.gunpowder": "Barıt",
  "item.minecraft.guster_banner_pattern": "Bayraq Naxışı",
  "item.minecraft.guster_banner_pattern.desc": "Çovğun",
  "item.minecraft.guster_banner_pattern.new": "Çovğun Bayraq Naxışı",
  "item.minecraft.guster_pottery_sherd": "Çovğun Dulusçuluq Parçası",
  "item.minecraft.happy_ghast_spawn_egg": "Xoşbəxt Qast Çağırma Yumurtası",
  "item.minecraft.harness": "Yəhər",
  "item.minecraft.heart_of_the_sea": "Dənizin ürəyi",
  "item.minecraft.heart_pottery_shard": "Ürək dulusçuluq parçası",
  "item.minecraft.heart_pottery_sherd": "Ürək dulusçuluq qabı",
  "item.minecraft.heartbreak_pottery_shard": "Ürək qıran dulusçuluq parçası",
  "item.minecraft.heartbreak_pottery_sherd": "Ürək qıran dulusçuluq",
  "item.minecraft.hoglin_spawn_egg": "Hoqlin çağırma yumurtası",
  "item.minecraft.honey_bottle": "Bal şüşəsi",
  "item.minecraft.honeycomb": "Bal pətəyi",
  "item.minecraft.hopper_minecart": "Süzgəcli Vaqon",
  "item.minecraft.horse_spawn_egg": "At çağırma yumurtası",
  "item.minecraft.host_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ev Sahibi Zireh Modeli",
  "item.minecraft.howl_pottery_shard": "Howl Saxsı Parçası",
  "item.minecraft.howl_pottery_sherd": "Howl Saxsı Sherd",
  "item.minecraft.husk_spawn_egg": "Hask çağırma yumurtası",
  "item.minecraft.ink_sac": "Mürəkkəb Kisəsi",
  "item.minecraft.iron_axe": "Dəmir Balta",
  "item.minecraft.iron_boots": "Dəmir Çəkmə",
  "item.minecraft.iron_chestplate": "Dəmir Sinəlik",
  "item.minecraft.iron_golem_spawn_egg": "Dəmir Golem Kürü Yumurtası",
  "item.minecraft.iron_helmet": "Dəmir Dəbilqə",
  "item.minecraft.iron_hoe": "Dəmir Kərki",
  "item.minecraft.iron_horse_armor": "Dəmir At Zirehi",
  "item.minecraft.iron_ingot": "Dəmir Külçə",
  "item.minecraft.iron_leggings": "Dəmir Şalvar",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Dəmir Parçası",
  "item.minecraft.iron_pickaxe": "Dəmir Qazma",
  "item.minecraft.iron_shovel": "Dəmir Kürək",
  "item.minecraft.iron_spear": "Dəmir nizə",
  "item.minecraft.iron_sword": "Dəmir Qılınc",
  "item.minecraft.item_frame": "Əşya Çərçivəsi",
  "item.minecraft.jungle_boat": "Cəngəllik Ağacı Qayıq",
  "item.minecraft.jungle_chest_boat": "Sandıqlı Cəngəllik Ağacı Qayıq",
  "item.minecraft.knowledge_book": "Bilik kitabı",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Lava Vedrəsi",
  "item.minecraft.lead": "Qayış",
  "item.minecraft.leather": "Dəri",
  "item.minecraft.leather_boots": "Dəri Ayaqqabı",
  "item.minecraft.leather_chestplate": "Dəri Zireh",
  "item.minecraft.leather_helmet": "Dəri Papaq",
  "item.minecraft.leather_horse_armor": "Dəri at zirehi",
  "item.minecraft.leather_leggings": "Dəri Şalvar",
  "item.minecraft.light_blue_bundle": "Açıq Göy Boğça",
  "item.minecraft.light_blue_dye": "Açıq Göy Boya",
  "item.minecraft.light_blue_harness": "Açıq Göy Yəhər",
  "item.minecraft.light_gray_bundle": "Açıq Boz Boğça",
  "item.minecraft.light_gray_dye": "Açıq Boz Boya",
  "item.minecraft.light_gray_harness": "Açıq Boz Yəhər",
  "item.minecraft.lime_bundle": "Açıq Yaşıl Boğça",
  "item.minecraft.lime_dye": "Açıq Yaşıl Boya",
  "item.minecraft.lime_harness": "Açıq Yaşıl Yəhər",
  "item.minecraft.lingering_potion": "Daimi Eliksir",
  "item.minecraft.lingering_potion.effect.awkward": "Daimi Qəribə Eliksir",
  "item.minecraft.lingering_potion.effect.empty": "Daimi Hazırlanmayan Eliksir",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Qalıcı odadavamlılıq iksiri",
  "item.minecraft.lingering_potion.effect.harming": "Daimi Xəsarət Eliksiri",
  "item.minecraft.lingering_potion.effect.healing": "Daimi Səhiyyət Eliksiri",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Daimi Görünməzlik Eliksiri",
  "item.minecraft.lingering_potion.effect.leaping": "Daimi Tullanma Eliksiri",
  "item.minecraft.lingering_potion.effect.levitation": "Daimi Yüksəlmə Eliksiri",
  "item.minecraft.lingering_potion.effect.luck": "Daimi Şans Eliksiri",
  "item.minecraft.lingering_potion.effect.mundane": "Daimi Adi Eliksir",
  "item.minecraft.lingering_potion.effect.night_vision": "Daimi Gecə Görüşü Eliksiri",
  "item.minecraft.lingering_potion.effect.oozing": "Daimi Sızma Iksiri",
  "item.minecraft.lingering_potion.effect.poison": "Daimi Zəhər Eliksiri",
  "item.minecraft.lingering_potion.effect.regeneration": "Daimi Təzələnmə Eliksiri",
  "item.minecraft.lingering_potion.effect.slow_falling": "Daimi Yavaş Eniş Eliksiri",
  "item.minecraft.lingering_potion.effect.slowness": "Daimi Yavaşlıq Eliksiri",
  "item.minecraft.lingering_potion.effect.strength": "Daimi Qüvvət Eliksiri",
  "item.minecraft.lingering_potion.effect.swiftness": "Daimi Çeviklik Eliksiri",
  "item.minecraft.lingering_potion.effect.thick": "Daimi Sıx Eliksir",
  "item.minecraft.lingering_potion.effect.turtle_master": "Daimi Tısbağa Ustası Eliksiri",
  "item.minecraft.lingering_potion.effect.water": "Daimi Su Butulkası",
  "item.minecraft.lingering_potion.effect.water_breathing": "Daimi Suda Nəfəs Alma Eliksiri",
  "item.minecraft.lingering_potion.effect.weakness": "Daimi Zəiflik Eliksiri",
  "item.minecraft.lingering_potion.effect.weaving": "Qalıcı Örmə Eliksiri",
  "item.minecraft.lingering_potion.effect.wind_charged": "Qalıcı Rüzgar Dolu Eliksiri",
  "item.minecraft.llama_spawn_egg": "Lama çağırma yumurtası",
  "item.minecraft.lodestone_compass": "Maqnitlənmiş kompas",
  "item.minecraft.mace": "Gürzü",
  "item.minecraft.magenta_bundle": "Eflatun Kisə",
  "item.minecraft.magenta_dye": "Magenta Boya",
  "item.minecraft.magenta_harness": "Eflatun Dizginləyici",
  "item.minecraft.magma_cream": "Magma Kremi",
  "item.minecraft.magma_cube_spawn_egg": "Maqma kubu çağırma yumurtası",
  "item.minecraft.mangrove_boat": "Manqrov Qayıq",
  "item.minecraft.mangrove_chest_boat": "Sandıqlı Manqrov Qayıq",
  "item.minecraft.map": "Boş Xəritə",
  "item.minecraft.melon_seeds": "Qarpız Toxumu",
  "item.minecraft.melon_slice": "Qarpız Dilimi",
  "item.minecraft.milk_bucket": "Süd Vedrəsi",
  "item.minecraft.minecart": "Vaqon",
  "item.minecraft.miner_pottery_shard": "Mədənçi Saxsı Parçası",
  "item.minecraft.miner_pottery_sherd": "Mədənçi dulusçuluq qabığı",
  "item.minecraft.mojang_banner_pattern": "Bayraq Modeli",
  "item.minecraft.mojang_banner_pattern.desc": "Şey",
  "item.minecraft.mojang_banner_pattern.new": "Şey Banner Naxışı",
  "item.minecraft.mooshroom_spawn_egg": "Muuşruum çağırma yumurtası",
  "item.minecraft.mourner_pottery_shard": "Yaslı Saxsı Parçası",
  "item.minecraft.mourner_pottery_sherd": "Yaslı Saxsı Sherd",
  "item.minecraft.mule_spawn_egg": "Qatır çağırma yumurtası",
  "item.minecraft.mushroom_stew": "Göbələk Pörtləməsi",
  "item.minecraft.music_disc_11": "Musiqi Diski",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musiqi Diski",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musiqi Diski",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musiqi Diski",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musiqi Diski",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musiqi Diski",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musiqi valı",
  "item.minecraft.music_disc_creator.desc": "Lena Reyn – Creator",
  "item.minecraft.music_disc_creator_music_box": "Musiqi valı",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Reyn – Creator (д",
  "item.minecraft.music_disc_far": "Musiqi valı",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Mahnı Diski",
  "item.minecraft.music_disc_lava_chicken.desc": "Lavalı Toyuq",
  "item.minecraft.music_disc_mall": "Musiqi diski",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musiqi valı",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musiqi valı",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musiqi Diski",
  "item.minecraft.music_disc_pigstep.desc": "Lena Rayn - Piqstep",
  "item.minecraft.music_disc_precipice": "Musiqi valı",
  "item.minecraft.music_disc_precipice.desc": "Aaron Şerof – Precipice",
  "item.minecraft.music_disc_relic": "Musiqi Diski",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relikt",
  "item.minecraft.music_disc_stal": "Musiqi Diski",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musiqi Diski",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musiqi Diski",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Göz Yaşları",
  "item.minecraft.music_disc_wait": "Musiqi Diski",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musiqi Diski",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Çiy Qoyun Əti",
  "item.minecraft.name_tag": "Ad Etiketi",
  "item.minecraft.nautilus_shell": "Nautilus qabığı",
  "item.minecraft.nautilus_spawn_egg": "Nautilus çağırma yumurtası",
  "item.minecraft.nether_brick": "Nether Kərpici",
  "item.minecraft.nether_star": "Nether Ulduzu",
  "item.minecraft.nether_wart": "Nether Ziyili",
  "item.minecraft.netherite_axe": "Nezerit balta",
  "item.minecraft.netherite_boots": "Nezerit çəkmə",
  "item.minecraft.netherite_chestplate": "Nezerit zireh",
  "item.minecraft.netherite_helmet": "Nezerit dəbilqə",
  "item.minecraft.netherite_hoe": "Nezerit toxa",
  "item.minecraft.netherite_horse_armor": "Nezerit at zirehi",
  "item.minecraft.netherite_ingot": "Nezerit külçəsi",
  "item.minecraft.netherite_leggings": "Nezerit şalvar",
  "item.minecraft.netherite_nautilus_armor": "Nezerit nautilus zirehi",
  "item.minecraft.netherite_pickaxe": "Nezerit qazma",
  "item.minecraft.netherite_scrap": "Nezerit parçası",
  "item.minecraft.netherite_shovel": "Nezerit kürək",
  "item.minecraft.netherite_spear": "Nezerit nizə",
  "item.minecraft.netherite_sword": "Nezerit qılınc",
  "item.minecraft.netherite_upgrade_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Kürdəmit Təkmilləşdirmə",
  "item.minecraft.oak_boat": "Palıd Qayıq",
  "item.minecraft.oak_chest_boat": "Sandıqlı Palıd Qayıq",
  "item.minecraft.ocelot_spawn_egg": "Oselot çağırma yumurtası",
  "item.minecraft.ominous_bottle": "Məşum şüşə",
  "item.minecraft.ominous_trial_key": "Məşum sınaq açarı",
  "item.minecraft.orange_bundle": "Narıncı kisə",
  "item.minecraft.orange_dye": "Narıncı Boya",
  "item.minecraft.orange_harness": "Narıncı qoşqu",
  "item.minecraft.painting": "Rəsm",
  "item.minecraft.pale_oak_boat": "Solğun palıd qayıq",
  "item.minecraft.pale_oak_chest_boat": "Solğun palıd sandıqlı qayıq",
  "item.minecraft.panda_spawn_egg": "Panda çağırma yumurtası",
  "item.minecraft.paper": "Kağız",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Tutuquşu çağırma yumurtası",
  "item.minecraft.phantom_membrane": "Fantom membranı",
  "item.minecraft.phantom_spawn_egg": "Fantom çağırma yumurtası",
  "item.minecraft.pig_spawn_egg": "Donuz çağırma yumurtası",
  "item.minecraft.piglin_banner_pattern": "Banner şablonu",
  "item.minecraft.piglin_banner_pattern.desc": "Donuz burnu",
  "item.minecraft.piglin_banner_pattern.new": "“Sifət” bayraq naxışı",
  "item.minecraft.piglin_brute_spawn_egg": "Qəddar Piqlin çağırma yumurtası",
  "item.minecraft.piglin_spawn_egg": "Piqlin çağırma yumurtası",
  "item.minecraft.pillager_spawn_egg": "Quldur çağırma yumurtası",
  "item.minecraft.pink_bundle": "Çəhrayı kisə",
  "item.minecraft.pink_dye": "Çəhrayı Boya",
  "item.minecraft.pink_harness": "Çəhrayı qoşqu",
  "item.minecraft.pitcher_plant": "Sürahi Zavodu",
  "item.minecraft.pitcher_pod": "Pitcher Under",
  "item.minecraft.plenty_pottery_shard": "Bol dulusçuluq parçası",
  "item.minecraft.plenty_pottery_sherd": "Bol dulusçuluq qabı",
  "item.minecraft.poisonous_potato": "Zəhərli Kartof",
  "item.minecraft.polar_bear_spawn_egg": "Qütb ayısı çağırma yumurtası",
  "item.minecraft.popped_chorus_fruit": "Partlamış Nəqarət Meyvəsi",
  "item.minecraft.porkchop": "Çiy Donuz Əti",
  "item.minecraft.potato": "Kartof",
  "item.minecraft.potion": "Eliksir",
  "item.minecraft.potion.effect.awkward": "Qəribə Eliksir",
  "item.minecraft.potion.effect.empty": "Hazırlanmayan Eliksir",
  "item.minecraft.potion.effect.fire_resistance": "Odadavamlılıq iksiri",
  "item.minecraft.potion.effect.harming": "Xəsarət Eliksiri",
  "item.minecraft.potion.effect.healing": "Səhiyyət Eliksiri",
  "item.minecraft.potion.effect.infested": "Təzələnmə Eliksiri",
  "item.minecraft.potion.effect.invisibility": "Görünməzlik Eliksiri",
  "item.minecraft.potion.effect.leaping": "Tullanma Eliksiri",
  "item.minecraft.potion.effect.levitation": "Yüksəlmə Eliksiri",
  "item.minecraft.potion.effect.luck": "Şans Eliksiri",
  "item.minecraft.potion.effect.mundane": "Adi Eliksir",
  "item.minecraft.potion.effect.night_vision": "Gecə Görüşü Eliksiri",
  "item.minecraft.potion.effect.oozing": "Sızma Eliksiri",
  "item.minecraft.potion.effect.poison": "Zəhər Eliksiri",
  "item.minecraft.potion.effect.regeneration": "Təzələnmə Eliksiri",
  "item.minecraft.potion.effect.slow_falling": "Yavaş Eniş Eliksiri",
  "item.minecraft.potion.effect.slowness": "Yavaşlıq Eliksiri",
  "item.minecraft.potion.effect.strength": "Qüvvət Eliksiri",
  "item.minecraft.potion.effect.swiftness": "Çeviklik Eliksiri",
  "item.minecraft.potion.effect.thick": "Sıx Eliksir",
  "item.minecraft.potion.effect.turtle_master": "Tısbağa Ustası Eliksiri",
  "item.minecraft.potion.effect.water": "Su Butulkası",
  "item.minecraft.potion.effect.water_breathing": "Suda Nəfəs Alma Eliksiri",
  "item.minecraft.potion.effect.weakness": "Zəiflik Eliksiri",
  "item.minecraft.potion.effect.weaving": "Hörmə iksiri",
  "item.minecraft.potion.effect.wind_charged": "Külək yükü iksiri",
  "item.minecraft.pottery_shard_archer": "Oxatan dulusçuluq parçası",
  "item.minecraft.pottery_shard_arms_up": "Dulusçuluq parçasını silahlandırın",
  "item.minecraft.pottery_shard_prize": "Mükafat dulusçuluq parçası",
  "item.minecraft.pottery_shard_skull": "Kəllə qabığı",
  "item.minecraft.powder_snow_bucket": "Tozlu qar vedrəsi",
  "item.minecraft.prismarine_crystals": "Prizmarin Kristalı",
  "item.minecraft.prismarine_shard": "Prizmarin Parçası",
  "item.minecraft.prize_pottery_shard": "Mükafat dulusçuluq parçası",
  "item.minecraft.prize_pottery_sherd": "Mükafat dulusçuluq qabı",
  "item.minecraft.pufferfish": "Kirpi Balığı",
  "item.minecraft.pufferfish_bucket": "Kirpi Balığı Vedrəsi",
  "item.minecraft.pufferfish_spawn_egg": "Kirpi balığı çağırma yumurtası",
  "item.minecraft.pumpkin_pie": "Balqabaq piroqu",
  "item.minecraft.pumpkin_seeds": "Balqabaq Toxumu",
  "item.minecraft.purple_bundle": "Bənövşəyi kisə",
  "item.minecraft.purple_dye": "Bənövşəyi Boya",
  "item.minecraft.purple_harness": "Bənö",
  "item.minecraft.quartz": "Nether Kvarsı",
  "item.minecraft.rabbit": "Çiy Dovşan Əti",
  "item.minecraft.rabbit_foot": "Dovşan Ayağı",
  "item.minecraft.rabbit_hide": "Dovşan Dərisi",
  "item.minecraft.rabbit_spawn_egg": "Dovşan çağırma yumurtası",
  "item.minecraft.rabbit_stew": "Dovşan Pörtləməsi",
  "item.minecraft.raiser_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Dağıdıcı çağırma yumurtası",
  "item.minecraft.raw_copper": "Xam Mis",
  "item.minecraft.raw_gold": "Xam Qızıl",
  "item.minecraft.raw_iron": "Xam Dəmir",
  "item.minecraft.recovery_compass": "Bərpa Kompası",
  "item.minecraft.red_bundle": "Qırmızı kisə",
  "item.minecraft.red_dye": "Qırmızı Boya",
  "item.minecraft.red_harness": "Qırmızı qoşqu",
  "item.minecraft.redstone": "Qızıl Daş Tozu",
  "item.minecraft.resin_brick": "Qatran kərpici",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Çürük Ət",
  "item.minecraft.saddle": "Yəhər",
  "item.minecraft.salmon": "Çiy Salmon",
  "item.minecraft.salmon_bucket": "Salmon Vedrəsi",
  "item.minecraft.salmon_spawn_egg": "Qızılbalıq çağırma yumurtası",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Saxsı qab qırıqları",
  "item.minecraft.sheaf_pottery_sherd": "Saxsı qab",
  "item.minecraft.shears": "Qayçı",
  "item.minecraft.sheep_spawn_egg": "Qoyun çağırma yumurtası",
  "item.minecraft.shelter_pottery_shard": "Sığınacaq Saxsı Parçası",
  "item.minecraft.shelter_pottery_sherd": "Sığınacaq dulusçuluq qabığı",
  "item.minecraft.shield": "Qalxan",
  "item.minecraft.shield.black": "Qara Qalxan",
  "item.minecraft.shield.blue": "Göy Qalxan",
  "item.minecraft.shield.brown": "Qəhvəyi Qalxan",
  "item.minecraft.shield.cyan": "Mavi Qalxan",
  "item.minecraft.shield.gray": "Boz Qalxan",
  "item.minecraft.shield.green": "Yaşıl Qalxan",
  "item.minecraft.shield.light_blue": "Açıq Göy Qalxan",
  "item.minecraft.shield.light_gray": "Açıq Boz Qalxan",
  "item.minecraft.shield.lime": "Açıq Yaşıl Qalxan",
  "item.minecraft.shield.magenta": "Magenta Qalxan",
  "item.minecraft.shield.orange": "Narıncı Qalxan",
  "item.minecraft.shield.pink": "Çəhrayı Qalxan",
  "item.minecraft.shield.purple": "Bənövşəyi Qalxan",
  "item.minecraft.shield.red": "Qırmızı Qalxan",
  "item.minecraft.shield.white": "Ağ Qalxan",
  "item.minecraft.shield.yellow": "Sarı Qalxan",
  "item.minecraft.shulker_shell": "Shulker Qabığı",
  "item.minecraft.shulker_spawn_egg": "Şalker çağırma yumurtası",
  "item.minecraft.sign": "Lövhə",
  "item.minecraft.silence_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Gümüş Böcəyi Peyda Yumurtası",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelet at çağırma yumurtası",
  "item.minecraft.skeleton_spawn_egg": "Skelet çağırma yumurtası",
  "item.minecraft.skull_banner_pattern": "Banner şablonu",
  "item.minecraft.skull_banner_pattern.desc": "Kəllə şəkli",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Kəllə qabığı",
  "item.minecraft.skull_pottery_sherd": "Kəllə dulusçuluq qabı",
  "item.minecraft.slime_ball": "Palçıq Topu",
  "item.minecraft.slime_spawn_egg": "Palçıq çağırma yumurtası",
  "item.minecraft.smithing_template": "Smithing Şablonu",
  "item.minecraft.smithing_template.applies_to": "Tətbiq olunur:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Külçə və ya kristal əlavə edin",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zireh",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Bir parça zireh əlavə edin",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Külçələr və Kristallar",
  "item.minecraft.smithing_template.ingredients": "Tərkibi:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Kürdəmit Külçə əlavə edin",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Almaz Avadanlıq",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Almaz zireh, silah və ya alət əlavə edin",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Kürdəmit Külçəsi",
  "item.minecraft.smithing_template.upgrade": "Təkmilləşdir: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Kürü Yumurtası",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Saxsı Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Kürü Yumurtası",
  "item.minecraft.snowball": "Qar Topu",
  "item.minecraft.spectral_arrow": "Spektral Ox",
  "item.minecraft.spider_eye": "Hörümçək Gözü",
  "item.minecraft.spider_spawn_egg": "Hörümçək çağırma yumurtası",
  "item.minecraft.spire_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Atıla Bilən Eliksir",
  "item.minecraft.splash_potion.effect.awkward": "Atıla Bilən Qəribə Eliksir",
  "item.minecraft.splash_potion.effect.empty": "Atıla Bilən Hazırlanmayan Eliksir",
  "item.minecraft.splash_potion.effect.fire_resistance": "Atılan odadavamlılıq iksiri",
  "item.minecraft.splash_potion.effect.harming": "Atıla Bilən Xəsarət Eliksiri",
  "item.minecraft.splash_potion.effect.healing": "Atıla Bilən Səhiyyət Eliksiri",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Atıla Bilən Görünməzlik Eliksiri",
  "item.minecraft.splash_potion.effect.leaping": "Atıla Bilən Tullanma Eliksiri",
  "item.minecraft.splash_potion.effect.levitation": "Atıla Bilən Yüksəlmə Eliksiri",
  "item.minecraft.splash_potion.effect.luck": "Atıla Bilən Şans Eliksiri",
  "item.minecraft.splash_potion.effect.mundane": "Atıla Bilən Adi Eliksir",
  "item.minecraft.splash_potion.effect.night_vision": "Atıla Bilən Gecə Görüşü Eliksiri",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Atıla Bilən Zəhər Eliksiri",
  "item.minecraft.splash_potion.effect.regeneration": "Atıla Bilən Təzələnmə Eliksiri",
  "item.minecraft.splash_potion.effect.slow_falling": "Atıla Bilən Yavaş Eniş Eliksiri",
  "item.minecraft.splash_potion.effect.slowness": "Atıla Bilən Yavaşlıq Eliksiri",
  "item.minecraft.splash_potion.effect.strength": "Atıla Bilən Qüvvət Eliksiri",
  "item.minecraft.splash_potion.effect.swiftness": "Atıla Bilən Çeviklik Eliksiri",
  "item.minecraft.splash_potion.effect.thick": "Atıla Bilən Sıx Eliksir",
  "item.minecraft.splash_potion.effect.turtle_master": "Atıla Bilən Tısbağa Ustası Eliksiri",
  "item.minecraft.splash_potion.effect.water": "Atıla Bilən Su Butulkası",
  "item.minecraft.splash_potion.effect.water_breathing": "Atıla Bilən Suda Nəfəs Alma Eliksiri",
  "item.minecraft.splash_potion.effect.weakness": "Atıla Bilən Zəiflik Eliksiri",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Ladin Qayıq",
  "item.minecraft.spruce_chest_boat": "Sandıqlı Ladin Qayıq",
  "item.minecraft.spyglass": "Durbin",
  "item.minecraft.squid_spawn_egg": "Kalmar çağırma yumurtası",
  "item.minecraft.stick": "Çubuq",
  "item.minecraft.stone_axe": "Daş Balta",
  "item.minecraft.stone_hoe": "Daş Kərki",
  "item.minecraft.stone_pickaxe": "Daş Qazma",
  "item.minecraft.stone_shovel": "Daş Kürək",
  "item.minecraft.stone_spear": "Daş nizə",
  "item.minecraft.stone_sword": "Daş Qılınc",
  "item.minecraft.stray_spawn_egg": "Strey çağırma yumurtası",
  "item.minecraft.strider_spawn_egg": "Strayder çağırma yumurtası",
  "item.minecraft.string": "İp",
  "item.minecraft.sugar": "Şəkər",
  "item.minecraft.suspicious_stew": "Şübhəli pörtləmə",
  "item.minecraft.sweet_berries": "Şirin giləmeyvə",
  "item.minecraft.tadpole_bucket": "Çömçəquyruq Vedrəsi",
  "item.minecraft.tadpole_spawn_egg": "Çömçəquyruq Çağırma Yumurtası",
  "item.minecraft.tide_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Eliksirli Ox",
  "item.minecraft.tipped_arrow.effect.awkward": "Eliksirli Ox",
  "item.minecraft.tipped_arrow.effect.empty": "Hazırlanmayan Eliksirli Ox",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Odadavamlılıq oxu",
  "item.minecraft.tipped_arrow.effect.harming": "Xəsarət Oxu",
  "item.minecraft.tipped_arrow.effect.healing": "Səhiyyət Oxu",
  "item.minecraft.tipped_arrow.effect.infested": "Təzələnmə Oxu",
  "item.minecraft.tipped_arrow.effect.invisibility": "Görünməzlik Oxu",
  "item.minecraft.tipped_arrow.effect.leaping": "Tulanma Oxu",
  "item.minecraft.tipped_arrow.effect.levitation": "Yüksəlmə Oxu",
  "item.minecraft.tipped_arrow.effect.luck": "Şans Oxu",
  "item.minecraft.tipped_arrow.effect.mundane": "Eliksirli Ox",
  "item.minecraft.tipped_arrow.effect.night_vision": "Gecə Görüşü Oxu",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Zəhər Oxu",
  "item.minecraft.tipped_arrow.effect.regeneration": "Təzələnmə Oxu",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Yavaş Eniş Oxu",
  "item.minecraft.tipped_arrow.effect.slowness": "Yavaşlıq Oxu",
  "item.minecraft.tipped_arrow.effect.strength": "Qüvvət Oxu",
  "item.minecraft.tipped_arrow.effect.swiftness": "Çeviklik Oxu",
  "item.minecraft.tipped_arrow.effect.thick": "Eliksirli Ox",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Tısbağa ustası oxu",
  "item.minecraft.tipped_arrow.effect.water": "Su Oxu",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Suda Nəfəs Alma Oxu",
  "item.minecraft.tipped_arrow.effect.weakness": "Zəiflik Oxu",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Külək yükü oxu",
  "item.minecraft.tnt_minecart": "TNT-li Vaqon",
  "item.minecraft.torchflower_seeds": "Məşəl çiçəyi toxumları",
  "item.minecraft.totem_of_undying": "Ölməmə Totemi",
  "item.minecraft.trader_llama_spawn_egg": "Tacir laması çağırma yumurtası",
  "item.minecraft.trial_key": "Sınaq Açarı",
  "item.minecraft.trident": "Üçbaşlı əsa",
  "item.minecraft.tropical_fish": "Tropik Balıq",
  "item.minecraft.tropical_fish_bucket": "Tropik balıq vedrəsi",
  "item.minecraft.tropical_fish_spawn_egg": "Tropik balıq çağırma yumurtası",
  "item.minecraft.turtle_helmet": "Tısbağa qabığı",
  "item.minecraft.turtle_scute": "Tısbağa Pulcuğu",
  "item.minecraft.turtle_spawn_egg": "Tısbağa çağırma yumurtası",
  "item.minecraft.vex_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Zərərli Zireh Modeli",
  "item.minecraft.vex_spawn_egg": "Veks çağırma yumurtası",
  "item.minecraft.villager_spawn_egg": "Kəndli çağırma yumurtası",
  "item.minecraft.vindicator_spawn_egg": "İntiqamçı çağırma yumurtası",
  "item.minecraft.wandering_trader_spawn_egg": "Səyyar tacir çağırma yumurtası",
  "item.minecraft.ward_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Keşikçi Çağırma Yumurtası",
  "item.minecraft.warped_fungus_on_a_stick": "Çubuqlu əyri göbələk",
  "item.minecraft.water_bucket": "Su Vedrəsi",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Buğda",
  "item.minecraft.wheat_seeds": "Buğda Toxumu",
  "item.minecraft.white_bundle": "Ağ kisə",
  "item.minecraft.white_dye": "Ağ Boya",
  "item.minecraft.white_harness": "Ağ qoşqu",
  "item.minecraft.wild_armor_trim_smithing_template": "Dəmirçi Şablonu",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Cadugər çağırma yumurtası",
  "item.minecraft.wither_skeleton_spawn_egg": "Vizer skeleti çağırma yumurtası",
  "item.minecraft.wither_spawn_egg": "Solmuş Kürü Yumurtası",
  "item.minecraft.wolf_armor": "Qurd Zirehi",
  "item.minecraft.wolf_spawn_egg": "Canavar çağırma yumurtası",
  "item.minecraft.wooden_axe": "Taxta Balta",
  "item.minecraft.wooden_hoe": "Taxta Kərki",
  "item.minecraft.wooden_pickaxe": "Taxta Qazma",
  "item.minecraft.wooden_shovel": "Taxta Kürək",
  "item.minecraft.wooden_spear": "Taxta nizə",
  "item.minecraft.wooden_sword": "Taxta Qılınc",
  "item.minecraft.writable_book": "Kitab və Tük",
  "item.minecraft.written_book": "Yazılı Kitab",
  "item.minecraft.yellow_bundle": "Sarı kisə",
  "item.minecraft.yellow_dye": "Sarı Boya",
  "item.minecraft.yellow_harness": "Sarı qoşqu",
  "item.minecraft.zoglin_spawn_egg": "Zoqlin çağırma yumurtası",
  "item.minecraft.zombie_horse_spawn_egg": "Zombi at çağırma yumurtası",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombi çağırma yumurtası",
  "item.minecraft.zombie_villager_spawn_egg": "Zombi kəndli çağırma yumurtası",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombiləşmiş piqlin çağırma yumurtası"
}
export const az_az = items; 
